import React, { useState, useRef, useEffect, useMemo } from "react"
import { Col, Container, Row } from "reactstrap"
import { Dropdown } from "primereact/dropdown"
import { TabView, TabPanel } from "primereact/tabview"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Sidebar } from "primereact/sidebar"
import { InputTextarea } from "primereact/inputtextarea"
import "jspdf-autotable"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import { Dialog } from "primereact/dialog"
import axios from "axios"
import { useForm } from "react-hook-form"
import moment from "moment"
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeTable } from "primereact/treetable"
import { Editor } from "primereact/editor"
import { Card } from "primereact/card"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { ProgressSpinner } from "primereact/progressspinner"

import AddContact from "./AddContact"

import { Calendar } from "primereact/calendar"
import LinkContactJob from "ATSComponents/Common/LinkContactJob"
import LinkCandidatesPopup from "ATSComponents/Common/LinkCandidatesPopup"

import Modal from "react-bootstrap/Modal"
import { FileUpload } from "primereact/fileupload"
import { CascadeSelect } from "primereact/cascadeselect"
import MoreACcompanies from "./MoreAC"
import { Toast } from "primereact/toast"
import { ConfirmationAlert, triggerAlert } from "utils/CommonFunctions"
import { Tooltip } from "primereact/tooltip"
import { Link } from "react-router-dom"
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import NotesCompanies1 from "ATSComponents/Common/NotesCompanies1"
import NotesCompanies from "ATSComponents/Common/NotesCompanies"
import { TreeSelect } from "primereact/treeselect"

import * as XLSX from "xlsx"
import { jsPDF } from "jspdf"
import { saveAs } from "file-saver"

import { useSelector, useDispatch } from "react-redux"
import { setPageData } from "store/actions"
import { setCompanySidebarVisible } from "store/actions"

//Meghana
import { ContextMenu } from "primereact/contextmenu"
import { useNavigate } from "react-router-dom"

//lokesh permisions

import { menuIdData } from "../../utils/Constants"
import { get_user_menu_permission } from "../../utils/CommonFunctions"
import { set } from "store"

import Swal from 'sweetalert2'

const CompaniesAllActive = ({ type, param }) => {
  const [addPermission, setAddPermission] = useState(false)
  const [editPermission, setEditPermission] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [viewPermission, setViewPermission] = useState(false)
  const [documentTypes, setDocumentTypes] = useState([])
  const [companyStatusOptions, setCompanyStatusOptions] = useState([]);
const [selectedCompanyStatus, setSelectedCompanyStatus] = useState(null);
const [statusLoaded, setStatusLoaded] = useState(false);
  const companySidebarVisible = useSelector(
    state => state.calendar.companySidebarVisible
  )

  const { first, rows, totalRecords } = useSelector(
    state => state.calendar.pagination
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (type === "my-active") {
      const menu_id = menuIdData?.MyActiveCompanies
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (param === "archived_only=true") {
      const menu_id = menuIdData?.ArchivedCompanies
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "duplicate-companies") {
      const menu_id = menuIdData?.CompaniesDuplicateList
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "activity_log") {
      const menu_id = menuIdData?.CompaniesActivityLog
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "task-list") {
      const menu_id = menuIdData?.CompaniesTaskList
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else {
      const menu_id = menuIdData?.AllActiveCompanies
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    }
  }, [])
const fetchCompanyStatusOptions = async () => {
  try {
    const response = await axios.get("/api/v1/company-status/");
    // The API returns an array of objects: [{id, company_status}, ...]
    const options = (response.data || []).map(item => ({
      label: item.company_status,
      value: item.id,
    }));
    setCompanyStatusOptions(options);

    // Set "Active" as default
    const activeOption = options.find(opt => opt.label === "Active");
    setSelectedCompanyStatus(activeOption ? activeOption.value : (options[0]?.value || null));
  } catch (error) {
    setCompanyStatusOptions([]);
    setSelectedCompanyStatus(null);
  }
};

useEffect(() => {
  // Fetch status options and set default before fetching company data
  const fetchStatusAndData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/v1/company-status/");
      const options = (response.data || []).map(item => ({
        label: item.company_status,
        value: item.id,
      }));
      setCompanyStatusOptions(options);

      // Set "Active" as default
      const activeOption = options.find(opt => opt.label === "Active");
      const defaultStatus = activeOption ? activeOption.value : (options[0]?.value || null);
      setSelectedCompanyStatus(defaultStatus);
      setStatusLoaded(true);

      // Fetch company data only after status is set
      const page = Math.floor(first / rows) + 1;
      await getCompanydata(page, type, param, defaultStatus, filters);
    } catch (error) {
      setCompanyStatusOptions([]);
      setSelectedCompanyStatus(null);
      setStatusLoaded(true);
    } finally {
      setLoading(false);
    }
  };

  fetchStatusAndData();
  // eslint-disable-next-line
}, []);

const isStatusActive = useMemo(() => {
  const activeOption = companyStatusOptions.find(opt => opt.label === "Active");
  return selectedCompanyStatus === (activeOption?.value ?? 1); // fallback to id 1 if not loaded yet
}, [selectedCompanyStatus, companyStatusOptions]);


  document.title = "ATS - Companies"

  const [selectedEmailOption, setSelectedEmailOption] = useState(null)
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    getValues,
  } = useForm()
  const [smShow, setSmShow] = useState(false)
  const [visibleViewRight, setVisibleViewRight] = useState(false)
  const [startyear, setstartyear] = useState(null)
  const [deleteRowId, setDeleteRowID] = useState(null) // end date value
  const [selectedSmsOption, setSelectedSmsOption] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)
  const [loading, setLoading] = useState(false)
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [pageState, setPageState] = useState({ first: 0, rows: 10 })
  const [showIconsSelect, setShowIconsSelect] = useState(false)
  const [showesitSelect, setshowesitSelect] = useState(true)
  const [selectedEmployees, setselectedEmployees] = useState(0)
  const [showesitSelecticon, setshowesitSelecticon] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null)

  const [errorMessage, setErrorMessage] = useState("")

  const [customers, setCustomers] = useState([])
  const dt = useRef(null)

  // Companies datatable filters
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    website: { value: null, matchMode: FilterMatchMode.CONTAINS },
    industry_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_size: { value: null, matchMode: FilterMatchMode.CONTAINS },
    founded_year: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    mobile_phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
    street_address: { value: null, matchMode: FilterMatchMode.CONTAINS },
    category_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    groups_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_ids: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    last_activity_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updated_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })


  // const onInputChange = (e, field, setFilterState, currentFilters) => {
  //     const value = e.target.value;

  //     setFilterState({
  //         ...currentFilters,
  //         [field]: {
  //             value,
  //             matchMode: currentFilters[field]?.matchMode || FilterMatchMode.CONTAINS,
  //         },
  //     });
  // };

  // Define filters to match DataTable column fields

  const [filtersActivityLog, setFiltersActivityLog] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    start_date_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // full_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.company_name": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "job.job_title": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.mobile_phone": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "company.category_name": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "company.groups_name": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.created_at": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.updated_at": { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  // Filters for DataTable
  const [filtersTaskList, setFiltersTaskLists] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    start_date_time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // full_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.company_name": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "job.job_title": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.mobile_phone": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "company.category_name": {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    "company.groups_name": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.created_at": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "company.updated_at": { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const [jobidsslectnames, setjobidsslectnames] = useState([])

  const onSelectionChange = e => {
    const selected = e.value || []
    setSelectedCustomers(selected)
    setselectedEmployees(selected.length)
    if (selected.length === 1) {
      setShowIconsSelect(false) // Show all icons
      setshowesitSelect(false)
      setshowesitSelecticon(true)
    } else if (selected.length > 1) {
      setShowIconsSelect(true)
      setshowesitSelect(false)
      setshowesitSelecticon(true)
    } else {
      setShowIconsSelect(false)
      setshowesitSelect(true)
      setshowesitSelecticon(false)
    }
    const selectedTitles = selected?.map(item => item?.event_type)
    setjobidsslectnames(selectedTitles)

    if (type === "task-list") {
    }
  }
  const getCandidateIds = () => {
    const selectedIds = selectedCustomers?.map(
      candidate => candidate?.company_id
    )
    setDeleteRowID(selectedIds)
    setSmShow(true)
  }

  const onloadcompany = data => {
    setValue("comapany", data?.company_name)
    setValue("personal_email", data.company_email)
    setValue("phone", data.mobile_phone)
    setValue("Specialties", data.specialties)
    setValue("Overview", data.description)
    setValue("website", data.website)
    if (data.founded_year && !isNaN(data.founded_year)) {
      setstartyear(new Date(`${data.founded_year}`))
    } else {
      setstartyear(null)
    }

    // Set address with names
    setTimeout(() => {
      setAddress(
        [
          data.street_address || "",
          data.street_address_line_2 || "",
          addCities.find(city => city.id === data.city)?.name || "",
          addStates.find(state => state.id === data.state)?.name || "",
          addCountries.find(country => country.id === data.country)?.name || "",
          data.pincode || "",
        ].filter(Boolean)
      )
    }, 1000)

    setStreet1(data.street_address)
    setStreet2(data.street_address_line_2)
    setPostalCode(data.pincode)
    setSelectedCountry(
      addCountries.find(country => country.id === data.country) || null
    )
    setSelectedCity(addCities.find(city => city.id === data.city) || null)
    setSelectedState(addStates.find(state => state.id === data.state) || null)
    // setSelectedCategoryKey(categoriesitem.find((category) => category.id === data.category) || null);

    setCompanySize(data.size)
    setIndustry(data.industry)
    setSelectedGroupKey(data.group)
    setSelectedCategoryKey(data.category)
  }

  const onRowReorder = e => {
    setCustomers(e.value)
  }
  const onCellEditComplete = e => {
    const { rowData, newValue, field } = e
    if (rowData[field] !== newValue) {
      const updatedCustomers = customers?.map(customer =>
        customer?.id === rowData?.id
          ? { ...customer, [field]: newValue }
          : customer
      )
      setCustomers(updatedCustomers)
      localStorage.setItem("customers", JSON.stringify(updatedCustomers))
    }
  }

  const [visible, setVisible] = useState(false) // State to control the visibility of the mo
  const [website, setWebsite] = useState("")
  const [visibleRight, setVisibleRight] = useState(false)
  const [companySize, setCompanySize] = useState(null)
  const [addStates, setAddStates] = useState([])
  const [addCities, setaddCities] = useState([])
  const [addCountries, setAddCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [industry, setIndustry] = useState(null)
  const [companysize, setcompanysize] = useState(null)
  const [industryview, setIndustryview] = useState([])
  const [companysizeview, setcompanysizeview] = useState([])

  const getindustry = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-industry-type/`, {})
      const transformedData = response?.data?.results?.map(Countries => ({
        name: Countries?.industry_name,
        id: Countries?.industry_id,
      }))
      setIndustryview(transformedData)
    } catch (error) {}
  }

  const getcompany = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-company-size/`, {})
      const transformedData = response?.data?.results?.map(Countries => ({
        name: Countries?.company_size,
        id: Countries?.id,
      }))
      setcompanysizeview(transformedData)
    } catch (error) {}
  }

  const getaddCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`, {})
      const transformedData = response?.data?.results?.map(Countries => ({
        name: Countries?.name,
        id: Countries?.country_id,
      }))
      setAddCountries(transformedData)
    } catch (error) {}
  }

  const getstateitems = async countryId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`,
        {}
      )
      const transformedData = response?.data?.results?.map(state => ({
        name: state?.name,
        id: state?.state_id,
      }))
      setAddStates(transformedData)
    } catch (error) {}
  }

  const getcity = async stateId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`,
        {}
      )
      const transformedData = response?.data?.results?.map(city => ({
        name: city?.name,
        id: city?.city_id,
      }))
      setaddCities(transformedData)
    } catch (error) {}
  }

  useEffect(() => {
    getaddCountries()
    getindustry()
    getcompany()
  }, [])

  useEffect(() => {
    if (selectedCountry) {
      getstateitems(selectedCountry)
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState) {
      getcity(selectedState)
    }
  }, [selectedState])

  const [uniqueUserId, setUniqueUserId] = useState("")

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"))
    if (userInfo && userInfo.user_details) {
      setUniqueUserId(userInfo.user_details.unique_user_id)
      setUserid([userInfo.user_details.unique_user_id])
    }
  }, [])

  const [compamyitem, setcompamyitem] = useState([])
  const [address, setAddress] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")
  const [selectedLabel, setSelectedLabel] = useState(null)

  useEffect(() => {
    setAddress(
      [
        street1 || "",
        street2 || "",
        selectedCity?.name || "", // Extract city name
        selectedState?.name || "", // Extract state name
        selectedCountry?.name || "", // Extract country name
        postalCode || "",
        selectedLabel?.name || "",
      ]
        .filter(Boolean)
        .join(", ")
    ) // Remove empty values
  }, [
    street1,
    street2,
    selectedCity,
    selectedState,
    selectedCountry,
    postalCode,
    selectedLabel,
  ])

  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 })
  // const [totalRecords, setTotalRecords] = useState(0);

  const onPageChange = event => {
    // setLazyParams({ page: event.page, rows: event.rows });
    const newPage = Math.floor(event.first / event.rows) + 1
    dispatch(
      setPageData({
        first: event.first,
        rows: event.rows,
        totalRecords,
      })
    )
    getCompanydata(newPage, type, param, selectedCompanyStatus, filters)
  }

  const handleStatusChanged = (newStatusValue) => {
  setSelectedCompanyStatus(newStatusValue); // Update dropdown
  setSelectedCustomers([]); // Clear selection
  const page = Math.floor(first / rows) + 1;
    dispatch(
    setPageData({
      first: (page - 1) * rows,
      rows: rows || 10,
      totalRecords,
    })
  );

  // Fetch data for the same page and new status
  getCompanydata(page, type, param, newStatusValue, filters);
};
  const [filteredAdminstation, setFilteredAdminstation] = useState([])
  const [dataLoading, setDataLoading] = useState(false)

  const getCompanydata = async (page, selectedType = "", param = "", statusId, filters = {}) => {
    setDataLoading(true)
    setCustomers([]) // Clear old data immediately to show loader
    try {
      let endpoint =
        selectedType === "activity_log"
          ? `/api/v1/activity-log/?module=Company&page=${page}&size=${rows}&status=${statusId}`
          : selectedType === "task-list"
          ? `/api/v1/events/task-list/?module=Company&page=${page}&size=${rows}&status=${statusId}`
          : `/api/v1/company${selectedType ? "/" + selectedType : ""}/?${
              param ? param + "&" : ""
            }page=${page}&size=${rows}&status=${statusId}`

      // Add filter query for main company API
      if (selectedType !== "activity_log" && selectedType !== "task-list") {
        let filterQuery = '';
        const keyMapping = {
          'industry_name': 'industry',
          'company_size': 'size',
          'groups_name': 'group',
          'company_name': 'company_name',
          'website': 'website',
          'founded_year': 'founded_year',
          'status': 'status',
          'company_email': 'company_email',
          'mobile_phone': 'mobile_phone',
          'category_name': 'category',
          'created_by_name': 'created_by_name',
          'last_activity_date': 'last_activity_date',
          'created_at': 'created_at',
          'updated_at': 'updated_at',
        };
        for (const [filterKey, apiKey] of Object.entries(keyMapping)) {
          if (filters[filterKey] && filters[filterKey].value) {
            const operator = filters[filterKey].matchMode.toLowerCase();
            filterQuery += `&${apiKey}__${operator}=${encodeURIComponent(filters[filterKey].value)}`;
          }
        }
        endpoint += filterQuery;
      }

      const response = await axios.get(endpoint)

      setCustomers(response.data.results)
      setFilteredAdminstation(response.data.results || [])
      setshowesitSelecticon(false)
      setshowesitSelect(true)
      setSelectedCustomers([])

      dispatch(
        setPageData({
          first: (page - 1) * rows,
          rows: rows || 10,
          totalRecords: response.data.count,
        })
      )
    } catch (error) {
      console.error("Error fetching company data:", error)
      setCustomers([]) // Ensure empty state on error
    } finally {
      setDataLoading(false)
    }
  }

  useEffect(() => {
    const page = Math.floor(first / rows) + 1
    getCompanydata(page, type, param, selectedCompanyStatus, filters)
  }, [first, rows, selectedCompanyStatus, filters])

  useEffect(() => {
    if (selectedCountry?.id) {
      getstateitems(selectedCountry.id)
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState?.id) {
      getcity(selectedState.id)
    }
  }, [selectedState])

  const [isEdited, setisEdited] = useState(false)
  const [editId, setEditId] = useState(null)
  const [disable, setDisable] = useState(false)

  const onSubmit = async data => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to save?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, create it!",
      backdrop: 'rgba(0,0,0,0.8)',
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: 'swal2-popup-custom'
      },
      didOpen: () => {
        const popup = Swal.getPopup();
        popup.style.zIndex = '10000';
        const container = popup.closest('.swal2-container');
        if (container) {
          container.style.zIndex = '10000';
        }
      }
    });

    if (!result.isConfirmed) {
      return; // User cancelled, do nothing
    }

    // setLoading(true);
    setDisable(true)
    const formattedtoDate = moment(startyear).format("YYYY")
    const req = {}

    req.private = data.relocation ? true : false

    if (data.jobtitle) {
      req.job_title = data.jobtitle
    }
    if (data.comapany) {
      req.company_name = data.comapany
    }
    if (data.personal_email) {
      req.company_email = data.personal_email
    }
    if (data.phone) {
      req.mobile_phone = data.phone
    }
    if (data.Specialties) {
      req.specialties = data.Specialties
    }
    if (data.website) {
      req.website = data.website
    }
    if (data.Overview) {
      req.description = data.Overview
    }
    if (companysize) {
      req.size = companysize
    }
    if (selectedCategoryNode) {
      req.category = selectedCategoryNode
    }
    if (selectedGroupNode) {
      req.group = selectedGroupNode
    }
    if (
      formattedtoDate &&
      !isNaN(formattedtoDate) &&
      Number(formattedtoDate) > 0
    ) {
      req.founded_year = Number(formattedtoDate)
    }
    if (website) {
      req.website = website
    }
    if (industry) {
      req.industry = industry
    }
    if (street1) {
      req.street_address = street1
    }
    if (street2) {
      req.street_address_line_2 = street2
    }
    if (selectedCity) {
      req.city = selectedCity?.id
    }
    if (selectedCountry) {
      req.country = selectedCountry?.id
    }
    if (selectedState) {
      req.state = selectedState?.id
    }
    if (postalCode) {
      req.pincode = postalCode
    }
    if (selectedLabel) {
      req.label = selectedLabel.code // Send the label ID
    }
    if (!isEdited) {
      try {
        var department = await axios.post(`/api/v1/company/`, req)
        if (department.data) {
          const page = Math.floor(first / rows) + 1
          getCompanydata(page, type, param ,selectedCompanyStatus, filters)
          Swal.fire({
            title: "Created!",
            text: "Company has been created successfully.",
            icon: "success"
          });
          dispatch(setCompanySidebarVisible(false))
          setSelectedCustomers([])
          setSelectedCategoryKey(null);
    setSelectedGroupKey(null);
    setcompanysize(null);
          setAddress("")
          setStreet1("")
          setStreet2("")
          setSelectedCountry(null)
          setSelectedState(null)
          setSelectedCity(null)
          setPostalCode("")
          setErrorMessage("")
          setSelectedLabel(null)
          setSelectedCategoryNode(null)
          setSelectedGroupNode(null)
        }
        // setLoading(false);
        setDisable(false)
      } catch (error) {
        const errorMessage =
          error.response?.data?.error ||
          "An error occurred while creating the company."
        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error"
        });
        // setLoading(false);
        setDisable(false)
      }
    } else {
      try {
        var response = await axios.put(`/api/v1/company/${editId}/`, req)
        if (response.data) {
          const page = Math.floor(first / rows) + 1
          getCompanydata(page, type, param, selectedCompanyStatus, filters)
          setshowesitSelect(true)
          setSelectedCustomers([])
          setshowesitSelecticon(false)
          dispatch(setCompanySidebarVisible(false))
          setSelectedLabel(null)
        }
        // setLoading(false);
        setDisable(false)
      } catch (error) {
        // setLoading(false);
        setDisable(false)
      }
    }
  }

  const [successAlert, setSuccessAlert] = useState(false)
  const deleteHandler = async () => {
    let id = deleteRowId
    try {
      const response = await axios.delete(`/api/v1/company/${id}/`)
      if (response.status === 200) {
        setSmShow(false)
        setshowesitSelecticon(false)
        setshowesitSelect(true)
        setShowIconsSelect(false)
        setSelectedCustomers([])
        setselectedEmployees(0)
        setSuccessAlert(true)
        // Optionally reload the window or update the state to reflect the deletion
        // window.location.reload();
        const page = Math.floor(first / rows) + 1
        getCompanydata(page, type, param, selectedCompanyStatus, filters)
      } else {
        console.error("Failed to delete the company.")
      }
    } catch (error) {
      console.error("Error deleting the company:", error)
      // Optionally show an error message to the user
    }
  }
  const [phoneNumber, setPhoneNumber] = useState("")
  const [workEmail, setWorkEmail] = useState("")
  const [description, setDescription] = useState("")
  const [primarySkillsvalu, setprimarySkillsvalu] = useState([])
  const [primarySkills, setPrimarySkills] = useState(null)
  const [conamyname, setconamyname] = useState(null)

  const [categoriesItem, setCategoriesItem] = useState("")
  const [groupItem, setGroupItem] = useState("")
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)
  const [selectedGroupKey, setSelectedGroupKey] = useState(null)

  //categories and groups done by lokesh
  const [categoryNodes, setCategoryNodes] = useState([])
  const [selectedCategoryNode, setSelectedCategoryNode] = useState(null)
  const [groupNodes, setGroupNodes] = useState([])
  const [selectedGroupNode, setSelectedGroupNode] = useState(null)

  // Transform categories to tree structure
  const transformCategoriesToTree = categories => {
    const buildTree = category => ({
      key: category?.category_id,
      label: category.name,
      data: category,
      children: category?.subcategories
        ? category?.subcategories?.map(buildTree)
        : [],
    })

    return categories?.map(buildTree)
  }

  // Transform groups to tree structure
  const transformGroupsToTree = groups => {
    const buildTree = group => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group?.subgroups ? group?.subgroups?.map(buildTree) : [],
    })

    return groups?.map(buildTree)
  }

  // Fetch categories
  const getCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response?.data && response?.data?.results) {
        const treeData = transformCategoriesToTree(response?.data?.results)
        setCategoryNodes(treeData)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }

  // Fetch groups
  const getGroups = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response?.data && response?.data?.results) {
        const groupTree = transformGroupsToTree(response?.data?.results)
        setGroupNodes(groupTree)
      }
    } catch (error) {
      console.error("Error fetching groups:", error)
    }
  }

  useEffect(() => {
    getCategories()
    getGroups()
  }, [])

  const [isPrivate, setIsPrivate] = useState(false)
  const [notes, setNotes] = useState("")

  const geteditvaluescondidates = async company_id => {
    try {
      const response = await axios.get(`/api/v1/company/${company_id}/`)
      // console.log(response.data, "lokesh")
      if (response.data) {
        let results = response.data
        setconamyname(results?.company_name)
        setPhoneNumber(results.mobile_phone)
        setWorkEmail(results.company_email)
        setWebsite(results.website)
        setIndustry(results.industry)
        setcompanysize(results.company_size)
        if (results.founded_year && !isNaN(results.founded_year)) {
          setstartyear(new Date(`${results.founded_year}`))
        } else {
          setstartyear(null)
        }
        // Set address with names
        setTimeout(() => {
          setAddress(
            [
              results.street_address || "",
              results.street_address_line_2 || "",
              addCities.find(city => city.id === results.city)?.name || "",
              addStates.find(state => state.id === results.state)?.name || "",
              addCountries.find(country => country.id === results.country)
                ?.name || "",
              results.pincode || "",
            ].filter(Boolean)
          )
        }, 1000)

        setIsPrivate(results.private)

        // setSelectedCategoryKey(results.category);
        // setSelectedGroupKey(results.group)
        setCategoriesItem(results.category_name)
        setGroupItem(results.groups_name)
        setValue("Specialties", results.specialties)
        // setSelectedNodeKey(results.categories)
        // setselectedgroupKey(results.groups)
        setPrimarySkills(results.primary_skills)
        setDescription(results.description)
        setNotes(results.notes)
      }
    } catch (error) {}
  }

  //lokesh
  const [isEditorVisible, setEditorVisible] = useState(false) // Manage editor visibility
  const [editorContent, setEditorContent] = useState("") // Manage editor content
  const [editNoteId, setEditNoteId] = useState(null)
  const [notesLoading, setNotesLoading] = useState(false)
  const [notesError, setNotesError] = useState(null)
  const [companyNotes, setCompanyNotes] = useState([]) // Store notes in an array
  const [documents, setDocuments] = useState([])
  const [documentsLoading, setDocumentsLoading] = useState(false)
  const [documentsError, setDocumentsError] = useState(null)

  const [updateLoading, setUpdateLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  const [editingRow, setEditingRow] = useState(null) // Tracks document_id being edited
  const [editValues, setEditValues] = useState({})

  const [archiveShow, setArchiveShow] = useState(false) // New state for archive modal
  const [archiveRowIds, setArchiveRowIds] = useState([]) // New state for archive IDs
  const [archiveLoading, setArchiveLoading] = useState(false) // New state for archive loading

  const [scheduleOptions, setScheduleOptions] = useState([]) // New state for dynamic schedule options
  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null)
  const [intertype, setIntertype] = useState("") // For handling selected schedule type
  const [interviewPop, setInterviewPop] = useState(false) // For handling interview popup

  // Dialog-related states (minimal set for demonstration)
  const [subtype, setSubtype] = useState(null)
  const [subjectval, setsubjectval] = useState("")
  const [popTextares, setPopTextares] = useState("")
  const [followup, setFollowup] = useState(null)
  const [repeat, setRepeat] = useState(null)
  const [reminder, setReminder] = useState("10 minutes")
  const [priority, setPriority] = useState(null)
  const [popchecked, setPopchecked] = useState(false)
  const [popchecked2, setPopchecked2] = useState(false)
  const [userid, setUserid] = useState([])

  const [typeInterview, setTypeInterview] = useState([]) // Sub-type options

  const [importCsvIcons, setImportCsvIcons] = useState(false)

  const toast = useRef(null)

  //Schedule Section Start
  const [selectedScheduleJob, setSelectedScheduleJob] = useState([])
  const [selectedScheduleContacts, setSelectedScheduleContacts] = useState([])
  const [selectedScheduleCandidates, setSelectedScheduleCandidates] = useState(
    []
  )
  const [isSubmitting, setIsSubmitting] = useState(false)

  const followupOptions = [
    { name: "None" },
    { name: "1 Day" },
    { name: "1 Week" },
  ]
  const repeatOptions = [
    { name: "None" },
    { name: "Daily" },
    { name: "Weekly" },
  ]
  const reminderOptions = [
    { name: "None" },
    { name: "15 Minutes" },
    { name: "1 Hour" },
  ]
  const priorityValue = [{ name: "Low" }, { name: "Medium" }, { name: "High" }]

  // Initialize default dates and times
  const now = new Date()
  const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000)
  const [startdate, setStartdate] = useState(now)
  const [starttime, setStarttime] = useState(now)
  const [enddate, setenddate] = useState(now)
  const [endtime, setendtime] = useState(oneHourLater)
  const [searchText, setSearchText] = useState("")

  const [callingtask, setcallingtask] = useState(false)
  const fetchScheduleTypes = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-schedule-type/`)
      const scheduleData = response.data?.results || []
      // Transform API data into an array for schedule options
      const transformedOptions = Array.isArray(scheduleData)
        ? scheduleData?.map(schedule => ({
            name: schedule?.schedule_type || "Unnamed Schedule",
            code: schedule?.id || "",
            action: () => setInterviewPop(true),
          }))
        : []
      setScheduleOptions(transformedOptions)
    } catch (error) {
      console.error("Error fetching schedule types:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch schedule types. Using default options.",
        life: 3000,
      })
      setScheduleOptions([]) // Ensure it's set to an empty array on error
    }
  }

  useEffect(() => {
    const now = new Date()

    const startDate = new Date() // today
    const endDate = new Date() // today

    const startTime = new Date() // current time
    const endTime = new Date(now.getTime() + 30 * 60000) // 30 minutes later

    setStartdate(startDate)
    setenddate(endDate)
    setStarttime(startTime)
    setendtime(endTime)
  }, [])

  const resetDefaultDateTime = () => {
    const now = new Date()
    const startDate = new Date() // today
    const endDate = new Date() // today
    const startTime = new Date() // now
    const endTime = new Date(now.getTime() + 30 * 60000) // 30 minutes later

    setStartdate(startDate)
    setenddate(endDate)
    setStarttime(startTime)
    setendtime(endTime)
  }

  // Fetch sub-types for Sub-Type Dropdown
  const fetchSubTypes = async scheduleId => {
    if (!scheduleId) return
    try {
      const response = await axios.get(
        `/api/v1/get-all-schedule-sub-type/?schedule_id=${scheduleId}`
      )
      const scheduleData = response.data?.results || []

      // Transform API data into flat list for Sub-Type Dropdown
      const transformedSubTypes = scheduleData?.map(schedule => ({
        name: schedule?.schedule_subtype || "Unnamed Sub-Type",
        code: schedule?.schedule_id || "",
      }))

      setTypeInterview(transformedSubTypes)
      setSubtype(null)
    } catch (error) {
      console.error("Error fetching sub-types:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch sub-types. Using default options.",
        life: 3000,
      })
    }
  }

  // Fetch data on component mount
  useEffect(() => {
    fetchScheduleTypes()
  }, [])

  const selectedScheduleTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`} />
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-calendar mr-2" />
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const scheduleOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`} />
        <div>{option.label}</div>
      </div>
    )
  }

  const saveSchedule = async () => {
    if (isSubmitting) return // prevent duplicate submission
    setIsSubmitting(true)
    const companyIds = selectedCustomers?.map(customer => customer?.company_id)
    const scheduleData = {
      job_id: selectedScheduleJob || null,
      company_id: companyIds,
      event_type: intertype || null,
      event_sub_type: subtype?.name || null,
      start_date: startdate ? moment(startdate).format("YYYY-MM-DD") : null,
      start_time: starttime ? moment(starttime).format("HH:mm:ss") : null,
      end_date: enddate ? moment(enddate).format("YYYY-MM-DD") : null,
      end_time: endtime ? moment(endtime).format("HH:mm:ss") : null,
      candidate_id: selectedScheduleCandidates,
      subject: subjectval || null,
      description: popTextares || null,
      event_priority: priority?.name || null, // Convert to lowercase to match payload
      completed: popchecked,
      private: popchecked2,
      user_ids: userid || [],
      auto_followup: followup?.name ? followup?.name : "",
      repeat: repeat?.name ? repeat?.name : "",
      reminder: reminder,
      contact_id: selectedScheduleContacts || null,
      event_time: moment().format("YYYY-MM-DDTHH:mm:ssZ"),
      status: 1, // Default status as per payload
    }

    try {
      const response = await axios.post(`/api/v1/events/`, scheduleData)

      if (response.data) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Schedule saved successfully",
          life: 2000,
        })
        setInterviewPop(false)
        setSelectedScheduleOption(null)
        resetForm()

        // Show warning toast for skipped contacts/candidates
        const resultArr = Array.isArray(response.data) ? response.data : [response.data];
        let skippedContactsMsg = "";
        let skippedCandidatesMsg = "";
        resultArr.forEach(result => {
          // Group contacts by reason
          if (result.skipped_contacts && result.skipped_contacts.length > 0) {
            const reasonMap = {};
            result.skipped_contacts.forEach(c => {
              if (!reasonMap[c.reason]) reasonMap[c.reason] = [];
              reasonMap[c.reason].push(c.contact_name);
            });
            Object.entries(reasonMap).forEach(([reason, names]) => {
              skippedContactsMsg += `${names.join(", ")} (${reason})\n`;
            });
          }
          // Group candidates by reason
          if (result.skipped_candidates && result.skipped_candidates.length > 0) {
            const reasonMap = {};
            result.skipped_candidates.forEach(c => {
              if (!reasonMap[c.reason]) reasonMap[c.reason] = [];
              reasonMap[c.reason].push(c.candidate_name);
            });
            Object.entries(reasonMap).forEach(([reason, names]) => {
              skippedCandidatesMsg += `${names.join(", ")} (${reason})\n`;
            });
          }
        });
        let warningMsg = "";
        if (skippedContactsMsg) warningMsg += skippedContactsMsg.trim();
        if (skippedContactsMsg && skippedCandidatesMsg) warningMsg += "\n";
        if (skippedCandidatesMsg) warningMsg += skippedCandidatesMsg.trim();
        if (warningMsg && toast && toast.current) {
          toast.current.show({ severity: 'warn', summary: 'Warning', detail: warningMsg, life: 6000 });
        }
      }
    } catch (error) {
      console.error("Error saving schedule:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.error || "Failed to save schedule",
        life: 3000,
      })
      setInterviewPop(false)
    } finally {
      setIsSubmitting(false) // reset flag after operation
    }
  }

  const [formErrors, setFormErrors] = useState({})

  const validateForm = () => {
    const newErrors = {}

    // Required fields
    // if (!subtype) newErrors.subtype = 'Sub-Type is required';
    if (!startdate) newErrors.startdate = "Start date is required"
    if (!starttime) newErrors.starttime = "Start time is required"
    if (!enddate) newErrors.enddate = "End date is required"
    if (!endtime) newErrors.endtime = "End time is required"
    // if (!subjectval?.trim()) newErrors.subjectval = 'Subject is required';
    // if (!popTextares?.trim()) newErrors.popTextares = 'Description is required';
    // if (!priority) newErrors.priority = 'Priority is required';
    // if (!userid?.length) newErrors.userid = 'At least one User ID is required';

    // Job, Contact, and Candidates are now optional
    // if (!selectedScheduleJob || selectedScheduleJob.length === 0)
    //   newErrors.selectedScheduleJob = "Job is required"
    // if (!selectedScheduleContacts || selectedScheduleContacts.length === 0) {
    //   newErrors.selectedScheduleContacts = "At least one contact is required"
    // }
    // if (
    //   !selectedScheduleCandidates ||
    //   selectedScheduleCandidates?.length === 0
    // ) {
    //   newErrors.selectedScheduleCandidates =
    //     "At least one candidate is required"
    // }

    // Date validations
    if (startdate && enddate && startdate > enddate) {
      newErrors.enddate = "End date must be after start date"
    }

    // Time validations for same day
    if (
      startdate &&
      enddate &&
      starttime &&
      endtime &&
      startdate.toDateString() === enddate.toDateString() &&
      starttime > endtime
    ) {
      newErrors.endtime = "End time must be after start time"
    }

    // Subject length validation
    // if (subjectval?.trim().length > 100) {
    //     newErrors.subjectval = 'Subject must be less than 100 characters';
    // }

    // Description length validation
    // if (popTextares?.trim().length > 500) {
    //     newErrors.popTextares = 'Description must be less than 500 characters';
    // }

    setFormErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const resetForm = () => {
    const now = new Date()
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000)
    setSubtype(null)
    setStartdate(now)
    setStarttime(now)
    setenddate(now)
    setendtime(oneHourLater)
    setsubjectval("")
    setPopTextares("")
    setPriority(null)
    // setUserid([]);
    setSelectedScheduleJob(null) // Reset job
    setSelectedScheduleContacts([]) // Reset contacts
    setSelectedScheduleCandidates([])
    setFormErrors({})
  }

  const handleSaveSchedule = () => {
    if (validateForm()) {
      saveSchedule()
    }
  }

  const handleScheduleChange = e => {
    setSelectedScheduleOption(e.value)
    setIntertype(e.value?.name || "") // Update intertype with selected schedule name
    // setSubtype(null);
    if (e.value?.code) {
      fetchSubTypes(e.value?.code) // Fetch subtypes based on selected schedule ID
    }
    if (e.value?.action) {
      e.value.action() // Trigger the action (e.g., open interview popup)
    }

    const selected = e.value

    if (
      selected?.name?.toLowerCase() === "call" ||
      selected?.name?.toLowerCase() === "meeting"
    ) {
      setcallingtask(true)
    } else {
      setcallingtask(false)
    }
  }

  // Dialog checkbox handlers
  const handlePopupCheckbox = e => setPopchecked(e.checked)
  const handlePopupCheckbox2 = e => setPopchecked2(e.checked)

  // Chips custom template (placeholder; replace with actual implementation)
  const customChip = item => <span>{item}</span>
  //Schedule section End

  //Archive section start
  const archiveUnarchiveHandler = async () => {
    setArchiveLoading(true)
    try {
      const companyIds = archiveRowIds.join(",")
      const endpoint =
        param === "archived_only=true"
          ? `/api/v1/company/${companyIds}/unarchive/`
          : `/api/v1/company/${companyIds}/archive/`
      await axios.patch(endpoint, {})
      const page = Math.floor(first / rows) + 1

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: `Companies ${
          param === "archived_only=true" ? "unarchived" : "archived"
        } successfully`,
        life: 3000,
      })

      setArchiveShow(false)
      setshowesitSelecticon(false)
      setshowesitSelect(true)
      setShowIconsSelect(false)
      setSelectedCustomers([])
      getCompanydata(page, type, param, selectedCompanyStatus, filters)
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        `Failed to ${
          param === "archived_only=true" ? "unarchive" : "archive"
        } companies. Please try again.`
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 3000,
      })
    } finally {
      setArchiveLoading(false)
    }
  }

  const handleArchiveUnarchiveClick = () => {
    const selectedIds = selectedCustomers?.map(
      candidate => candidate?.company_id
    )
    setArchiveRowIds(selectedIds)
    setArchiveShow(true)
  }

  //Archive section End

  //Documents Section Start
  const fetchCompanyDocuments = async companyId => {
    if (!companyId) {
      setDocumentsError("No company selected.")
      setDocuments([])
      return
    }

    setDocumentsLoading(true)
    setDocumentsError(null)

    try {
      const response = await axios.get(
        `/api/v1/documents/?company_id=${companyId}`
      )
      const rawDocuments = response.data?.results || []

      // Transform the API response to match TreeTable column fields
      const transformedDocuments = rawDocuments?.map(doc => ({
        key: doc?.document_id, // Unique key for TreeTable
        data: {
          docType: doc?.document_type_name || "Unknown", // Map document_type to docType
          docTypeId: doc?.document_type,
          docSubject: doc?.document_subject || "No Subject", // Map document_subject to docSubject
          appliedDateTime: doc?.created_at
            ? moment(doc?.created_at).format("YYYY-MM-DD HH:mm") // Format created_at
            : "N/A",
          document_id: doc?.document_id, // Keep for actions if needed
          attachments: doc?.attachments, // Include attachments if needed for actions
        },
        children: [], // Empty children for flat structure (no hierarchy)
      }))

      setDocuments(transformedDocuments)
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to fetch documents. Please try again."
      setDocumentsError(errorMessage)
      console.error("Error fetching company documents:", error)
      setDocuments([])
    } finally {
      setDocumentsLoading(false)
    }
  }

  // const updateCompanyDocument = async (
  //   documentId,
  //   documentType,
  //   documentSubject
  // ) => {
  //   if (!documentType || !documentSubject) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "Document type and subject are required.",
  //       life: 3000,
  //     })
  //     return
  //   }

  //   setUpdateLoading(true)

  //   try {
  //     const response = await axios.put(`/api/v1/documents/${documentId}/`, {
  //       document_type: documentType,
  //       document_subject: documentSubject,
  //     })

  //     const updatedDocument = response.data
  //     setDocuments(prevDocuments =>
  //       prevDocuments?.map(doc =>
  //         doc.key === documentId
  //           ? {
  //               ...doc,
  //               data: {
  //                 ...doc?.data,
  //                 docType: updatedDocument?.document_type_name || "Unknown",
  //                 docSubject: updatedDocument?.document_subject || "No Subject",
  //                 appliedDateTime: updatedDocument?.updated_at
  //                   ? moment(updatedDocument?.updated_at).format(
  //                       "DD/MM/YYYY HH:mm"
  //                     )
  //                   : doc.data.appliedDateTime,
  //                 document_id: updatedDocument?.document_id,
  //                 attachments: updatedDocument?.attachments || [],
  //               },
  //             }
  //           : doc
  //       )
  //     )

  //     toast.current.show({
  //       severity: "success",
  //       summary: "Success",
  //       detail: "Document updated successfully",
  //       life: 3000,
  //     })
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "Failed to update document. Please try again."
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: errorMessage,
  //       life: 3000,
  //     })
  //     console.error("Error updating document:", error)
  //   } finally {
  //     setUpdateLoading(false)
  //     setEditingRow(null)
  //     setEditValues({})
  //   }
  // }
  // ...existing code...
const updateCompanyDocument = async (
  documentId,
  documentTypeValue, // now this is the name
  documentSubject
) => {
  if (!documentTypeValue || !documentSubject) {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: "Document type and subject are required.",
      life: 3000,
    })
    return
  }

  setUpdateLoading(true)

  try {
    const response = await axios.put(`/api/v1/documents/${documentId}/`, {
      document_type: documentTypeValue, // send the name
      document_subject: documentSubject,
    })

    const updatedDocument = response.data
    setDocuments(prevDocuments =>
      prevDocuments?.map(doc =>
        doc.key === documentId
          ? {
              ...doc,
              data: {
                ...doc?.data,
                docType: updatedDocument?.document_type_name || "Unknown",
                docSubject: updatedDocument?.document_subject || "No Subject",
                appliedDateTime: updatedDocument?.updated_at
                  ? moment(updatedDocument?.updated_at).format(
                      "YYYY-MM-DD HH:mm"
                    )
                  : doc.data.appliedDateTime,
                document_id: updatedDocument?.document_id,
                attachments: updatedDocument?.attachments || [],
              },
            }
          : doc
      )
    )

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Document updated successfully",
      life: 3000,
    })
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      "Failed to update document. Please try again."
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: errorMessage,
      life: 3000,
    })
    console.error("Error updating document:", error)
  } finally {
    setUpdateLoading(false)
    setEditingRow(null)
    setEditValues({})
  }
}

// ...existing code...
  

  const deleteCompanyDocument = async documentId => {
    setDeleteLoading(true)

    try {
      await axios.delete(`/api/v1/documents/${documentId}/`)

      setDocuments(prevDocuments =>
        prevDocuments?.filter(doc => doc?.key !== documentId)
      )

      triggerAlert("success", "Success", "Document deleted successfully!")
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to delete document. Please try again."
      triggerAlert("error", "Error", errorMessage)

      console.error("Error deleting document:", error)
    } finally {
      setDeleteLoading(false)
    }
  }
  const handleEdit = key => {
    const rowData = documents.find(doc => doc.key === key)
    setEditingRow(key)
    setEditValues({
      docType: rowData.data.docType,
      docSubject: rowData.data.docSubject,
    })
  }

  const handleSave = () => {
    if (editingRow) {
      updateCompanyDocument(
        editingRow,
        editValues.docType,
        editValues.docSubject
      )
    }
  }

  const handleDelete = key => {
    setVisibleViewRight(false) // Hide sidebar when delete is confirmed
    ConfirmationAlert(
      "Are you sure you want to delete this document?",
      "Yes, delete it!",
      () => {
        deleteCompanyDocument(key) // Call the deletion function
      }
    )
  }

  const actionTemplate = rowData => {
    return (
      <div className="flex gap-2">
        {editingRow === rowData.key ? (
          <Button
            icon="pi pi-check"
            rounded
            outlined
            className="document-btn"
            onClick={handleSave}
            tooltip="Save"
            tooltipOptions={{ position: "top" }}
            disabled={updateLoading || deleteLoading}
          />
        ) : (
          <Button
            icon="pi pi-pencil"
            rounded
            outlined
            className="document-btn"
            onClick={() => handleEdit(rowData.key)}
            tooltip="Edit Document"
            tooltipOptions={{ position: "top" }}
            disabled={updateLoading || deleteLoading}
          />
        )}
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          className="document-btn"
          onClick={() => handleDelete(rowData.key)}
          tooltip="Delete Document"
          tooltipOptions={{ position: "top" }}
          disabled={updateLoading || deleteLoading}
        />
      </div>
    )
  }

  // const columnBodyTemplate = (rowData, field) => {
  //   if (field === "appliedDateTime") {
  //     return <span>{rowData.data[field]}</span>
  //   }

  //   const isEditing = editingRow === rowData.key
  //   const value = isEditing
  //     ? editValues[field] || rowData.data[field]
  //     : rowData.data[field]

  //   return isEditing ? (
  //     <InputText
  //       value={value}
  //       onChange={e =>
  //         setEditValues(prev => ({ ...prev, [field]: e.target.value }))
  //       }
  //       onKeyDown={e => {
  //         if (e.key === "Enter") {
  //           handleSave()
  //         } else if (e.key === "Escape") {
  //           setEditingRow(null)
  //           setEditValues({})
  //         }
  //       }}
  //       autoFocus
  //       className="w-full"
  //     />
  //   ) : (
  //     <span>{value}</span>
  //   )
  // }

  // Add this function above the TreeTable rendering
  

const columnBodyTemplate = (rowData, field) => {
  if (field === "appliedDateTime") {
    return <span>{rowData.data[field]}</span>
  }

  const isEditing = editingRow === rowData.key
  const value = isEditing
    ? editValues[field] || rowData.data[field]
    : rowData.data[field]

  // Show Dropdown for docType when editing
  if (isEditing && field === "docType") {
    return (
      <Dropdown
        value={editValues.docType || rowData.data.docType}
        options={documentTypes}
        onChange={e =>
          setEditValues(prev => ({
            ...prev,
            docType: e.value, // value is the name
          }))
        }
        placeholder="Select Document Type"
        optionLabel="label"
        optionValue="value" // value is the name
        className="w-full"
        autoFocus
      />
    )
  }

  if (isEditing && field === "docSubject") {
    return (
      <InputText
        value={value}
        onChange={e =>
          setEditValues(prev => ({ ...prev, docSubject: e.target.value }))
        }
        onKeyDown={e => {
          if (e.key === "Enter") {
            handleSave()
          } else if (e.key === "Escape") {
            setEditingRow(null)
            setEditValues({})
          }
        }}
        autoFocus
        className="w-full"
      />
    )
  }

  return <span>{value}</span>
}

// ...existing code...
  const attachmentBodyTemplate = rowData => {
    const attachments = rowData.data.attachments || []
    const maxFileNameLength = 20

    if (attachments.length === 0) {
      return <span>No attachments</span>
    }

    const truncateFileName = fileName => {
      if (fileName.length <= maxFileNameLength) return fileName
      const extension = fileName.split(".").pop()
      const nameWithoutExtension = fileName.slice(0, -(extension.length + 1))
      return `${nameWithoutExtension.slice(
        0,
        maxFileNameLength - extension.length - 3
      )}...${extension}`
    }

    return (
      <div className="flex flex-column gap-2">
        {attachments?.map(attachment => (
          <a
            key={attachment?.attachment_id}
            href={attachment?.file_path}
            download={attachment?.file_name}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
            title={`Download ${attachment?.file_name}`}
          >
            {truncateFileName(attachment?.file_name)}
          </a>
        ))}
      </div>
    )
  }

  // Fetch documents when the sidebar is opened and a company is selected
  useEffect(() => {
    if (visibleViewRight && selectedCustomers[0]?.company_id) {
      fetchCompanyDocuments(selectedCustomers[0]?.company_id)
    } else {
      // Reset documents if no company is selected
      setDocuments([])
      setDocumentsError(null)
    }
  }, [visibleViewRight, selectedCustomers])

  // Documents Section End

  // Notes Section start
  const fetchCompanyNotes = async companyId => {
    setNotesLoading(true)
    setNotesError(null)
    try {
      const response = await axios.get(`/api/v1/notes/?company_id=${companyId}`)
      // console.log("Fetched Notes", response.data)
      setCompanyNotes(response?.data?.results || [])
    } catch (error) {
      setNotesError("Failed to fetch notes. Please try again.")
      console.error("Fetch notes error:", error)
    } finally {
      setNotesLoading(false)
    }
  }

  // Create a new note
  const createCompanyNote = async (companyId, noteContent) => {
    if (!companyId) {
      setNotesError("No company selected.")
      return false
    }
    setNotesLoading(true)
    setNotesError(null)
    try {
      const response = await axios.post(`/api/v1/notes/`, {
        company_id: companyId,
        notes: noteContent,
      })
      await fetchCompanyNotes(companyId)

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Notes Created successfully",
        life: 3000,
      })

      setEditorContent("")
      setEditorVisible(false)
      return true
    } catch (error) {
      setNotesError("Failed to create note. Please try again.")
      console.error("Create note error:", error)
      return false
    } finally {
      setNotesLoading(false)
    }
  }

  // Update an existing note
  const updateCompanyNote = async (noteId, companyId, noteContent) => {
    if (!noteId || !companyId) {
      setNotesError("Invalid note or company ID.")
      return false
    }
    setNotesLoading(true)
    setNotesError(null)
    try {
      const response = await axios.put(`/api/v1/notes/${noteId}/`, {
        company_id: companyId,
        notes: noteContent,
      })
      setCompanyNotes(prevNotes =>
        prevNotes?.map(note =>
          note?.note_id === noteId ? { ...note, ...response?.data } : note
        )
      )

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Notes Updated successfully",
        life: 3000,
      })
      setEditorContent("")
      setEditorVisible(false)
      setEditNoteId(null)
      return true
    } catch (error) {
      setNotesError("Failed to update note. Please try again.")
      console.error("Update note error:", error)
      return false
    } finally {
      setNotesLoading(false)
    }
  }

  // Delete a note
  const deleteCompanyNote = async noteId => {
    if (!noteId) {
      setNotesError("Invalid note ID.")
      return false
    }
    setNotesLoading(true)
    setNotesError(null)
    try {
      await axios.delete(`/api/v1/notes/${noteId}/`)
      // console.log("Deleted note ID:", noteId);
      setCompanyNotes(prevNotes =>
        prevNotes?.filter(note => note?.note_id !== noteId)
      )

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Notes deleted successfully",
        life: 3000,
      })
      return true
    } catch (error) {
      setNotesError("Failed to delete note. Please try again.")
      console.error("Delete note error:", error)
      return false
    } finally {
      setNotesLoading(false)
    }
  }

  const handleAddNotes = () => {
    setEditorVisible(true) // Show the editor
    setEditorContent("") // Clear any previous content
    setEditNoteId(null)
    setNotesError(null)
  }

  // const handleSaveNotes = async () => {
  //   if (!editorContent.trim()) {
  //     setNotesError("Note content cannot be empty.")
  //     return
  //   }

  //   const companyId = selectedCustomers[0]?.company_id // Get company ID from selected customer
  //   if (!companyId) {
  //     setNotesError("No company selected.")
  //     return
  //   }

  //   if (editNoteId) {
  //     await updateCompanyNote(editNoteId, companyId, editorContent)
  //   } else {
  //     // Create new note
  //     await createCompanyNote(companyId, editorContent)
  //   }
  // }
  const handleSaveNotes = async () => {
    if (!editorContent.trim()) {
      setNotesError("Note content cannot be empty.")
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Note content cannot be empty.",
        life: 3000,
      })
      setVisibleViewRight(false) // Close the view sidebar
      return
    }

    const companyId = selectedCustomers[0]?.company_id
    if (!companyId) {
      setNotesError("No company selected.")
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "No company selected.",
        life: 3000,
      })
      setVisibleViewRight(false) // Close the view sidebar
      return
    }

    if (editNoteId) {
      await updateCompanyNote(editNoteId, companyId, editorContent)
    } else {
      await createCompanyNote(companyId, editorContent)
    }
    setVisibleViewRight(false) // Close the view sidebar after successful save
  }

  const handleCancelNotes = () => {
    setEditorContent("")
    setEditorVisible(false)
    setEditNoteId(null)
    setNotesError(null)
  }

  const handleEditNote = note => {
    setEditorVisible(true)
    setEditorContent(note.notes)
    setEditNoteId(note.note_id)
    setNotesError(null)
  }

  const handleDeleteNote = async noteId => {
    await deleteCompanyNote(noteId)
  }

  useEffect(() => {
    if (visibleViewRight && selectedCustomers[0]?.company_id) {
      fetchCompanyNotes(selectedCustomers[0].company_id)
    }
  }, [visibleViewRight, selectedCustomers])

  //Notes Section End

  //pipeline section start

  const [stages, setStages] = useState([])
  const [pipelineData, setPipelineData] = useState({})
  const [stageCounts, setStageCounts] = useState({})
  const [selectedJobs, setSelectedJobs] = useState({})
  const [pipelineFilters, setPipelineFilters] = useState({})

  // Initialize filters for each stage
  const initFilters = {
    stage: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jobid: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    contact: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    create_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    createdBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
  }

  // Fetch stages from API
  const fetchStages = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-stages/")
      if (response.data && response.data.results) {
        // Sort stages by order
        const sortedStages = response?.data?.results
          .sort((a, b) => a?.order - b?.order)
          .map(stage => stage?.name?.toLowerCase())
        setStages(sortedStages)

        // Initialize state for each stage
        const initialPipelineData = {}
        const initialStageCounts = {}
        const initialSelectedJobs = {}
        const initialFilters = {}
        sortedStages?.forEach(stage => {
          initialPipelineData[stage] = []
          initialStageCounts[stage] = 0
          initialSelectedJobs[stage] = []
          initialFilters[stage] = initFilters
        })
        setPipelineData(initialPipelineData)
        setStageCounts(initialStageCounts)
        setSelectedJobs(initialSelectedJobs)
        // setFilters(initialFilters);
      } else {
        console.warn("No stages found in API response.")
        setStages([])
      }
    } catch (error) {
      console.error("Error fetching stages:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch stages. Please try again.",
        life: 3000,
      })
    }
  }

  // Fetch pipeline data
  const fetchPipelineData = async companyId => {
    if (!companyId) {
      console.error("No company ID provided.")
      return
    }

    try {
      const response = await axios.get(
        `/api/v1/stages/job_candidates_by_stage/?company_id=${companyId}`
      )

      if (response.data && response.data.results) {
        // Transform the API response to match DataTable structure
        const newPipelineData = {}
        const newStageCounts = {}
        stages?.forEach(stage => {
          newPipelineData[stage] = []
          newStageCounts[stage] = 0
        })

        response?.data?.results?.forEach(stageData => {
          const stageKey = stageData?.stage_name?.toLowerCase()
          if (stages?.includes(stageKey)) {
            newStageCounts[stageKey] = stageData?.count || 0
            newPipelineData[stageKey] = stageData?.candidates?.map(
              candidate => ({
                stage: stageData?.stage_name,
                jobid: candidate?.job?.job_number || "N/A",
                job_title: candidate?.job?.job_title || "N/A",
                contact: candidate?.candidate_name || "N/A",
                status: candidate?.status || "N/A",
                create_date: candidate?.created_at
                  ? moment(candidate?.created_at).format("YYYY-MM-DD")
                  : "N/A",
                createdBy: candidate?.created_by_meta ? candidate?.created_by_meta : candidate?.created_by_name || "N/A",
                candidate: candidate?.candidate_name || "N/A",
                location: candidate?.job?.location || "N/A",
              })
            )
          }
        })

        setPipelineData(newPipelineData)
        setStageCounts(newStageCounts)
      } else {
        console.warn("No results found in API response.")
        const emptyPipelineData = {}
        const emptyStageCounts = {}
        stages?.forEach(stage => {
          emptyPipelineData[stage] = []
          emptyStageCounts[stage] = 0
        })
        setPipelineData(emptyPipelineData)
        setStageCounts(emptyStageCounts)
      }
    } catch (error) {
      console.error("Error fetching pipeline data:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch pipeline data. Please try again.",
        life: 3000,
      })
      const emptyPipelineData = {}
      const emptyStageCounts = {}
      stages?.forEach(stage => {
        emptyPipelineData[stage] = []
        emptyStageCounts[stage] = 0
      })
      setPipelineData(emptyPipelineData)
      setStageCounts(emptyStageCounts)
    }
  }

  // Fetch stages and pipeline data
  useEffect(() => {
    fetchStages()
  }, [])

  useEffect(() => {
    if (
      visibleViewRight &&
      selectedCustomers[0]?.company_id &&
      stages.length > 0
    ) {
      fetchPipelineData(selectedCustomers[0].company_id)
    }
  }, [visibleViewRight, selectedCustomers, stages])
  // Handle selection change for a specific stage
  const handleSelectionChange = (stage, value) => {
    setSelectedJobs(prev => ({
      ...prev,
      [stage]: value,
    }))
  }
  // Fetch stages and pipeline data when component mounts or companyId changes
  useEffect(() => {
    fetchStages()
  }, [])

  useEffect(() => {
    if (visibleViewRight && selectedCustomers[0]?.company_id) {
      fetchPipelineData(selectedCustomers[0].company_id)
    }
  }, [visibleViewRight, selectedCustomers, stages])

  //pipeline section end

  //Company Contacts section start
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [contacts, setContacts] = useState([])
  const [contactsLoading, setContactsLoading] = useState(false)
  const [contactsError, setContactsError] = useState(null)
  const [selectedContacts, setSelectedContacts] = useState([])
  const [contactsFilters, setContactsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    full_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    work_phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
    work_email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    city: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const [filteredContacts, setFilteredContacts] = useState([])

  const [contactsTotalRecords, setContactsTotalRecords] = useState(0)

  const fetchCompanyContacts = async (
    companyId,
    page = 1,
    size = rowsPerPage
  ) => {
    if (!companyId) {
      setContactsError("No company selected.")
      setContacts([])
      return
    }

    setContactsLoading(true)
    setContactsError(null)

    try {
      const response = await axios.get(
        `/api/v1/company-contacts/?company_id=${companyId}&page=${page}&size=${size}`
      )
      const rawContacts = response.data?.results || []
      const totalCount = response.data?.count || 0
      // Transform the API response to match DataTable column fields
      const transformedContacts = rawContacts?.map(contact => ({
        full_name:
          contact?.first_name && contact?.last_name
            ? `${contact?.first_name} ${contact?.last_name}`
            : contact?.first_name || contact?.last_name || "N/A",
        job_title: contact?.job_title || "N/A",
        work_phone: contact?.phone_number || "N/A",
        work_email: contact?.email || "N/A",
        city: contact?.city_name || "N/A",
        user_id: contact?.created_by_name || "N/A",
      }))

      setContacts(transformedContacts)
      setContactsTotalRecords(totalCount)
      setCurrentPage(page)
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to fetch contacts. Please try again."
      setContactsError(errorMessage)
      console.error("Error fetching company contacts:", error)
      setContacts([])
    } finally {
      setContactsLoading(false)
    }
  }

  useEffect(() => {
    let filtered = [...contacts]

    Object.entries(contactsFilters)?.forEach(([field, filterMeta]) => {
      const { value, matchMode } = filterMeta
      if (value) {
        filtered = filtered?.filter(item => {
          const fieldValue = item[field]?.toString().toLowerCase() || ""
          const filterValue = value?.toLowerCase()
          return fieldValue?.includes(filterValue)
        })
      }
    })

    setFilteredContacts(filtered)
  }, [contacts, contactsFilters])
  // Fetch contacts when the sidebar is opened and a company is selected
  useEffect(() => {
    if (visibleViewRight && selectedCustomers[0]?.company_id) {
      fetchCompanyContacts(
        selectedCustomers[0].company_id,
        currentPage,
        rowsPerPage
      )
    } else {
      // Reset contacts if no company is selected
      setContacts([])
      setContactsError(null)
      setContactsTotalRecords(0)
    }
  }, [visibleViewRight, selectedCustomers, rowsPerPage])

  //Company contact section End

  //Activities section start
  const [activityTotalRecords, setActivityTotalRecords] = useState(0)

  const [activities, setActivities] = useState([])
  const [selectedActivities, setSelectedActivities] = useState([])
  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })
  const [filteredActivities, setFilteredActivities] = useState([])

  const fetchActivities = async (companyId, page = 1, size = rowsPerPage) => {
    // setLoading(true);
    try {
      const response = await axios.get(
        `/api/v1/activity-log/?company_id=${companyId}&page=${page}&size=${size}`
      )

      const rawActivities = response.data?.results || []

      const totalCount = response.data?.count || 0

      const formattedData = rawActivities?.map((item, index) => ({
        id: item?.calendar_id || index + 1,
        event_type: item?.event_type || "N/A",
        event_sub_type: item?.event_sub_type || "N/A",
        event_priority: item?.event_priority || "N/A",
        subject: item?.subject || "N/A",
        status: item?.status || "N/A",
        start_date: item?.start_date
          ? moment(item.start_date).format("YYYY-MM-DD")
          : "N/A",
        end_date: item?.end_date
          ? moment(item?.end_date).format("YYYY-MM-DD")
          : "N/A",
        created_by_name: item?.created_by_name || "N/A",
      }))

      setActivities(formattedData)
      setActivityTotalRecords(totalCount)
      setCurrentPage(page)
    } catch (error) {
      console.error("Error fetching activities:", error)
      setActivities([])
      setActivityTotalRecords(0)
    }
  }

  useEffect(() => {
    let filtered = [...activities]

    Object.entries(activitiesFilters).forEach(([field, filterMeta]) => {
      const { value, matchMode } = filterMeta
      if (value) {
        filtered = filtered?.filter(item => {
          const fieldValue = item[field]?.toString().toLowerCase() || ""
          const filterValue = value?.toLowerCase()
          return fieldValue?.includes(filterValue)
        })
      }
    })

    setFilteredActivities(filtered)
  }, [activities, activitiesFilters])

  // Fetch data on component mount
  useEffect(() => {
    if (visibleViewRight && selectedCustomers[0]?.company_id) {
      fetchActivities(selectedCustomers[0].company_id, currentPage, rowsPerPage)
    } else {
      // Reset contacts if no company is selected
      setActivities([])
      setActivityTotalRecords(0)
    }
  }, [visibleViewRight, selectedCustomers, rowsPerPage])
  //Activities section end

  //condidates and history section start
  const [candidates, setCandidates] = useState([])
  const [history, setHistory] = useState([])
  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [selectedHistory, setSelectedHistory] = useState([])
  const [candidatesError, setCandidatesError] = useState(null)
  const [historyError, setHistoryError] = useState(null)
  const [historyTotalRecords, setHistoryTotalRecords] = useState(0)
  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    dateTime: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })
  const [candidateTotalRecords, setCandidateTotalRecords] = useState(0)
  const [candidatesFilters, setCandidatesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    full_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    mob_phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    city: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })
  const [filteredCandidates, setFilteredCandidates] = useState([])
  const [filteredHistory, setFilteredHistory] = useState([])

  const fetchCompanyCandidates = async (
    companyId,
    page = 1,
    size = rowsPerPage
  ) => {
    if (!companyId) {
      setCandidatesError("No company selected.")
      setCandidates([])
      return
    }

    // setLoading(true);
    setCandidatesError(null)

    try {
      const response = await axios.get(
        `/api/v1/company/${companyId}/candidates-under-company/?page=${page}&size=${size}`
      )
      const rawCandidates = response.data?.results || []

      const totalCount = response.data?.count || 0
      // Transform the API response to match DataTable column fields
      const transformedCandidates = rawCandidates?.map((candidate, index) => ({
        id: candidate?.candidate_id || index + 1,
        full_name:
          candidate?.first_name && candidate?.last_name
            ? `${candidate.first_name} ${candidate.last_name}`
            : candidate?.first_name || candidate?.last_name || "N/A",
        job_title: candidate?.job_title || "N/A",
        mob_phone: candidate?.mobile_phone || "N/A",
        email: candidate?.email || "N/A",
        city: candidate?.city_name || "N/A",
        user_id: candidate?.created_by_name || "N/A",
      }))

      setCandidates(transformedCandidates)
      setCandidateTotalRecords(totalCount)
      setCurrentPage(page)
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to fetch candidates. Please try again."
      setCandidatesError(errorMessage)
      console.error("Error fetching company candidates:", error)
      setCandidates([])
      setCandidateTotalRecords(0)
    }
  }

  // Fetch history for a company
  const fetchCompanyHistory = async (
    companyId,
    page = 1,
    size = rowsPerPage
  ) => {
    if (!companyId) {
      setHistoryError("No company selected.")
      setHistoryTotalRecords(0)
      setHistory([])
      return
    }

    // setLoading(true);
    setHistoryError(null)

    try {
      const response = await axios.get(
        `/api/v1/history/?company_id=${companyId}&page=${page}&size=${size}`
      )
      const rawHistory = response.data?.results || []

      const totalCount = response.data?.count || 0

      // Transform the API response to match DataTable column fields
      const formattedHistory = rawHistory?.map((item, index) => ({
        id: item?.id || (page - 1) * rowsPerPage + index + 1, // Unique ID for DataTable
        type: item?.type || "N/A",
        sub_type: item?.sub_type || "N/A",
        priority: item?.priority || "N/A",
        subject: item?.subject || "N/A",
        dateTime: item?.datetime
          ? moment(item?.dateTime).format("YYYY-MM-DD HH:mm")
          : "N/A",
        user_id: item?.user_id || "N/A",
      }))

      setHistory(formattedHistory)
      setHistoryTotalRecords(totalCount)
      setCurrentPage(page)
    } catch (error) {
      const errorMessage = error.response?.data?.message
      setHistoryError(errorMessage)
      console.error("Error fetching company history:", error)
      setHistoryTotalRecords(0)
      setHistory([])
    }
  }

  useEffect(() => {
    let filtered = [...candidates]

    Object.entries(candidatesFilters).forEach(([field, filterMeta]) => {
      const { value, matchMode } = filterMeta
      if (value) {
        filtered = filtered?.filter(item => {
          const fieldValue = item[field]?.toString().toLowerCase() || ""
          return fieldValue?.includes(value.toLowerCase())
        })
      }
    })

    setFilteredCandidates(filtered)
  }, [candidates, candidatesFilters])

  useEffect(() => {
    let filtered = [...history]

    Object.entries(historyFilters).forEach(([field, filterMeta]) => {
      const { value, matchMode } = filterMeta
      if (value) {
        filtered = filtered.filter(item => {
          const fieldValue = item[field]?.toString().toLowerCase() || ""
          return fieldValue?.includes(value?.toLowerCase())
        })
      }
    })

    setFilteredHistory(filtered)
  }, [history, historyFilters])

  useEffect(() => {
    if (visibleViewRight && selectedCustomers[0]?.company_id) {
      fetchCompanyCandidates(
        selectedCustomers[0].company_id,
        currentPage,
        rowsPerPage
      )
      fetchCompanyHistory(
        selectedCustomers[0].company_id,
        currentPage,
        rowsPerPage
      )
    } else {
      // Reset candidates and history if no company is selected
      setCandidates([])
      setCandidatesError(null)
      setHistory([])
      setHistoryError(null)
    }
  }, [visibleViewRight, selectedCustomers, rowsPerPage])

  //candidates and history section end

  // Export code start
  const exportCSVBtn = selectionOnly => {
    if (dt.current) {
      dt.current.exportCSV({ selectionOnly })
    } else {
      alert("DataTable reference not found.")
    }
  }

  // Function to export to PDF
  // const exportPdfBtn = selectionOnly => {
  //   const dataToExport = selectionOnly ? selectedCustomers : customers
  //   if (dataToExport.length === 0) {
  //     alert("No data available for export.")
  //     return
  //   }

  //   const doc = new jsPDF("landscape")
  //   let exportColumns = []
  //   let exportData = []

  //   if (type === "task-list") {
  //     exportColumns = [
  //       "Event Type",
  //       "Event Sub Type",
  //       "Event Time",
  //       "Start Date Time",
  //       "End Date Time",
  //       "Event Priority",
  //       "Subject",
  //       "Status",
  //       "Created By",
  //     ]

  //     exportData = dataToExport.map(row => [
  //       row?.event_type || "-",
  //       row.event_sub_type || "-",
  //       row.event_time
  //         ? moment(row.event_time).format("DD/MM/YYYY HH:mm")
  //         : "-",
  //       row.startDateTime
  //         ? moment(row.startDateTime).format("DD/MM/YYYY HH:mm")
  //         : "-",
  //       row.endDateTime
  //         ? moment(row.endDateTime).format("DD/MM/YYYY HH:mm")
  //         : "-",
  //       row.event_priority || "-",
  //       row.subject || "-",
  //       row.status || "-",
  //       row.created_by_name || "-",
  //     ])
  //   } else if (type === "activity_log") {
  //     exportColumns = [
  //       "Event Type",
  //       "Event Sub Type",
  //       "Event Priority",
  //       "Subject",
  //       "Status",
  //       "Start Date",
  //       "End Date",
  //       "Created By",
  //     ]

  //     exportData = dataToExport.map(row => [
  //       row?.event_type || "-",
  //       row.event_sub_type || "-",
  //       row.event_priority || "-",
  //       row.subject || "-",
  //       row.status || "-",
  //       row.start_date ? moment(row.start_date).format("DD/MM/YYYY") : "-",
  //       row.end_date ? moment(row.end_date).format("DD/MM/YYYY") : "-",
  //       row.created_by_name || "-",
  //     ])
  //   } else {
  //     exportColumns = [
  //       "Company",
  //       "Website",
  //       "Industry",
  //       "Company Size",
  //       "Year Founded",
  //       "Email",
  //       "Mobile Phone",
  //       "Address",
  //       "Category",
  //       "Group",
  //       "Created By",
  //       "Last Activity Date",
  //     ]

  //     exportData = dataToExport.map(row => [
  //       row?.company_name || "-",
  //       row.website || "-",
  //       row.industry_name || "-",
  //       row.company_size || "-",
  //       row.founded_year || "-",
  //       row.company_email || "-",
  //       row.mobile_phone || "-",
  //       row.street_address || "-",
  //       row.category_name || "-",
  //       row.groups_name || "-",
  //       row.created_by_name || "-",
  //       row.last_activity_date
  //         ? moment(row.last_activity_date).format("DD/MM/YYYY HH:mm")
  //         : "-",
  //     ])
  //   }

  //   doc.autoTable({
  //     head: [exportColumns],
  //     body: exportData,
  //     startY: 20,
  //     styles: { fontSize: 8, cellPadding: 2 },
  //     theme: "grid",
  //     margin: { top: 10, left: 5, right: 5 },
  //     columnStyles: { 0: { cellWidth: 30 } },
  //   })

  //   doc.save("company_data.pdf")
  // }

  const exportPdfBtn = selectionOnly => {
  const dataToExport = selectionOnly ? selectedCustomers : customers;
  if (dataToExport.length === 0) {
    alert("No data available for export.");
    return;
  }

  const doc = new jsPDF("landscape");

  // List all columns you want to export (matching your DataTable)
  const exportColumns = [
    "Company",
    "Website",
    "Industry",
    "Company Size",
    "Year Founded",
    "Status",
    "Email",
    "Mobile Phone",
    "Address",
    "Category",
    "Group",
    "Created By",
    "Last Activity Date",
    "Create Date",
    "Edit Date"
  ];

  // Map your data to match the columns above
  const exportData = dataToExport.map(row => [
    row?.company_name || "-",
    row?.website || "-",
    row?.industry_name || "-",
    row?.company_size || "-",
    row?.founded_year || "-",
    row?.status || "-",
    row?.company_email || "-",
    row?.mobile_phone || "-",
    [
      row?.street_address,
      row?.street_address_line_2,
      row?.city_name,
      row?.state_name,
      row?.country_name,
      row?.pincode
    ].filter(Boolean).join(", "),
    row?.category_name || "-",
    row?.groups_name || "-",
    row?.created_by_name || "-",
    row?.last_activity_date
      ? moment(row.last_activity_date).format("DD/MM/YYYY HH:mm")
      : "-",
    row?.created_at
      ? moment(row.created_at).format("YYYY-MM-DD")
      : "-",
    row?.updated_at
      ? moment(row.updated_at).format("YYYY-MM-DD")
      : "-"
  ]);

  doc.autoTable({
    head: [exportColumns],
    body: exportData,
    startY: 20,
    styles: { fontSize: 8, cellPadding: 2 },
    theme: "grid",
    margin: { top: 10, left: 5, right: 5 },
    columnStyles: { 0: { cellWidth: 30 } }
  });

  doc.save("company_data.pdf");
};

  // Function to export to Excel
  const exportExcelBtn = selectionOnly => {
    const dataToExport = selectionOnly ? selectedCustomers : customers
    if (dataToExport.length === 0) {
      alert("No data available for export.")
      return
    }

    let exportData = []

    if (type === "task-list") {
      exportData = dataToExport.map(row => ({
        "Event Type": row?.event_type || "-",
        "Event Sub Type": row.event_sub_type || "-",
        "Event Time": row.event_time
          ? moment(row.event_time).format("DD/MM/YYYY HH:mm")
          : "-",
        "Start Date ": row.start_date
          ? moment(row.start_date).format("YYYY-MM-DD")
          : "-",
        "End Date ": row.end_date
          ? moment(row.end_date).format("YYYY-MM-DD")
          : "-",
        "Event Priority": row.event_priority || "-",
        Subject: row.subject || "-",
        Status: row.status || "-",
        "Created By": row.created_by_name || "-",
      }))
    } else if (type === "activity_log") {
      exportData = dataToExport.map(row => ({
        "Event Type": row?.event_type || "-",
        "Event Sub Type": row.event_sub_type || "-",
        "Event Priority": row.event_priority || "-",
        Subject: row.subject || "-",
        Status: row.status || "-",
        "Start Date": row.start_date
          ? moment(row.start_date).format("YYYY-MM-DD")
          : "-",
        "End Date": row.end_date
          ? moment(row.end_date).format("YYYY-MM-DD")
          : "-",
        "Created By": row.created_by_name || "-",
      }))
    } else {
      exportData = dataToExport.map(row => ({
        Company: row?.company_name || "-",
        Website: row.website || "-",
        Industry: row.industry_name || "-",
        "Company Size": row.company_size || "-",
        "Year Founded": row.founded_year || "-",
        Email: row.company_email || "-",
        "Mobile Phone": row.mobile_phone || "-",
        Address: row.street_address || "-",
        Category: row.category_name || "-",
        Group: row.groups_name || "-",
        "User ID": row.user_ids || "-",
        "Created By": row.created_by_name || "-",
        "Last Activity Date": row.last_activity_date
          ? moment(row.last_activity_date).format("YYYY-MM-DD HH:mm")
          : "-",
      }))
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })
    saveAsExcelFile(excelBuffer, "company_data")
  }

  // Function to save the Excel file
  const saveAsExcelFile = (buffer, fileName) => {
    const data = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    saveAs(data, `${fileName}_export_${new Date().getTime()}.xlsx`)
  }

  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      {selectedCustomers.length > 0 ? (
        <>
          <Button
            className="csvbtn p-button"
            icon="pi pi-file"
            rounded
            onClick={() => exportCSVBtn(true)}
            tooltip="Export Selected to CSV"
          />
          <Button
            className="xlsbtn p-button"
            icon="pi pi-file-excel"
            severity="success"
            rounded
            onClick={() => exportExcelBtn(true)}
            tooltip="Export Selected to Excel"
          />
          <Button
            className="pdfbtn p-button me-2"
            icon="pi pi-file-pdf"
            severity="warning"
            rounded
            onClick={() => exportPdfBtn(true)}
            tooltip="Export Selected to PDF"
          />
        </>
      ) : (
        <>
          <Button
            className="csvbtn p-button"
            icon="pi pi-file"
            rounded
            onClick={() => exportCSVBtn(false)}
            tooltip="Export to CSV"
          />
          <Button
            className="xlsbtn p-button"
            icon="pi pi-file-excel"
            severity="success"
            rounded
            onClick={() => exportExcelBtn(false)}
            tooltip="Export to Excel"
          />
          <Button
            className="pdfbtn p-button me-2"
            icon="pi pi-file-pdf"
            severity="warning"
            rounded
            onClick={() => exportPdfBtn(false)}
            disabled={customers.length === 0}
            tooltip="Export to PDF"
          />
        </>
      )}
    </div>
  )

  // Export code end

  const handleClearSearchCompanies = () => {
    const initialFilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      company_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      website: { value: null, matchMode: FilterMatchMode.CONTAINS },
      industry_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      company_size: { value: null, matchMode: FilterMatchMode.CONTAINS },
      founded_year: { value: null, matchMode: FilterMatchMode.CONTAINS },
      // description: { value: null, matchMode: FilterMatchMode.CONTAINS },
      company_email: { value: null, matchMode: FilterMatchMode.CONTAINS },
      mobile_phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
      street_address: { value: null, matchMode: FilterMatchMode.CONTAINS },
      // notes: { value: null, matchMode: FilterMatchMode.CONTAINS },
      category_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      groups_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      user_ids: { value: null, matchMode: FilterMatchMode.CONTAINS },
      created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
      last_activity_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
      updated_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    }
    setFilters(initialFilters)
    setFiltersActivityLog({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event_sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event_priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
      subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
      description: { value: null, matchMode: FilterMatchMode.CONTAINS },
      start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })

    setFiltersTaskLists({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      event_sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      startDateTime: { value: null, matchMode: FilterMatchMode.EQUALS },
      endDateTime: { value: null, matchMode: FilterMatchMode.EQUALS },
      event_priority: { value: null, matchMode: FilterMatchMode.CONTAINS },
      subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
      status: { value: null, matchMode: FilterMatchMode.CONTAINS },
      created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })

    if (dt.current) {
      dt.current.reset()
    }
  }

  // Function to truncate text to a specified number of words
  const truncateText = (text, maxWords = 8) => {
    if (!text) return ""
    const words = text.split(" ")
    if (words.length <= maxWords) return text
    return words.slice(0, maxWords).join(" ") + "..."
  }

  const [labels, setLabels] = useState([])
  const [isGeneratingInfo, setIsGeneratingInfo] = useState(false)
  
  const fetchLabels = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-address-label/")
      const labelsData = response.data.results || response.data || []
      setLabels(
        labelsData?.map(item => ({
          name: item?.address_label,
          code: item?.id,
        }))
      )
    } catch (error) {
      console.error("Error fetching labels:", error)
      triggerAlert("error", "Error", "Failed to fetch address labels")
      setLabels([])
    }
  }

  // Function to call company info API
  const generateCompanyInfo = async (companyName, websiteUrl) => {
    if (!companyName && !websiteUrl) return
    
    setIsGeneratingInfo(true)
    try {
      const response = await axios.post(
        '/api/v1/company/get-company-info/',
        {
          company_name: companyName || '',
          company_website_name: websiteUrl || ''
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo4NTQsInVuaXF1ZV91c2VyX2lkIjoiYXRzdGVhbSIsImNvbXBhbnlfaWQiOjIwLCJ1c2VybmFtZSI6bnVsbCwiZW1haWwiOiJhdHN0ZWFtQG1haWwuY29tIiwiZXhwIjoxNzYzNzI2NTA3LCJpYXQiOjE3NjExMzQ1MDd9.qF2t3gyBM2tgoWl5ih2o02jT2LwnCVFV6oHZPEYZjoQ'
          }
        }
      )
      
      if (response.data && response.data.Company_info && response.data.Company_info.length > 0) {
        const companyInfo = response.data.Company_info[0].company_info
        if (companyInfo) {
          setValue("Overview", companyInfo)
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: "Company information generated successfully",
            life: 3000,
          })
        }
      } else {
        toast.current?.show({
          severity: "info",
          summary: "Info",
          detail: "No company information found",
          life: 3000,
        })
      }
    } catch (error) {
      console.error("Error generating company info:", error)
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to generate company information",
        life: 3000,
      })
    } finally {
      setIsGeneratingInfo(false)
    }
  }

  // Debounced function to trigger API call
  const debouncedGenerateInfo = useRef(null)
  
  const handleCompanyNameChange = (value) => {
    if (debouncedGenerateInfo.current) {
      clearTimeout(debouncedGenerateInfo.current)
    }
    
    debouncedGenerateInfo.current = setTimeout(() => {
      const websiteValue = getValues("website")
      if (value?.trim() || websiteValue?.trim()) {
        generateCompanyInfo(value?.trim(), websiteValue?.trim())
      }
    }, 1000) // Wait 1 second after user stops typing
  }
  
  const handleWebsiteChange = (value) => {
    if (debouncedGenerateInfo.current) {
      clearTimeout(debouncedGenerateInfo.current)
    }
    
    debouncedGenerateInfo.current = setTimeout(() => {
      const companyValue = getValues("comapany")
      if (value?.trim() || companyValue?.trim()) {
        generateCompanyInfo(companyValue?.trim(), value?.trim())
      }
    }, 1000) // Wait 1 second after user stops typing
  }
  
  useEffect(() => {
    fetchLabels()
  }, [])

  // Handle OK button click in address dialog
  const handleOkClick = () => {
    // Concatenate address fields, filtering out empty values
    const addressParts = [
      street1 + " " + street2,
      selectedCountry?.name,
      selectedState?.name,
      selectedCity?.name,
      postalCode,
      selectedLabel?.name,
    ].filter(part => part && part.trim() !== "")

    // Join parts with new lines
    const formattedAddress = addressParts.join("\n")
    setAddress(formattedAddress)
    setVisible(false) // Close dialog
  }

  // Handle dialog hide (cancel or close)
  const handleDialogHide = () => {
    if (!visible) return
    // Clear address and reset fields
    setAddress("")
    setStreet1("")
    setStreet2("")
    setSelectedCountry(null)
    setSelectedState(null)
    setSelectedCity(null)
    setPostalCode("")
    setErrorMessage("")
    setVisible(false)
  }

  // more attachment
  // const onUpload = (event) => {
  //     toast.current.show({ severity: 'info', summary: 'Success', detail: `${event.files.length} file(s) uploaded` });
  // };
  // more attachment

  //Meghana

  const cm = useRef(null)
  const notesContactRef = useRef(null)
  const notesContactRef1 = useRef(null)
  const moreACContactsRef = useRef()

  const navigate = useNavigate()

  const [selectedCompany, setSelectedCompany] = useState(null) // State to track the right-clicked company

  const debounceTimeout = useRef(null)

  const handleEditCompany = company => {
    if (company) {
      navigate(`/companies-editform?company_id=${company.company_id}`)
    }
  }

  const handleUnarchive = ids => {
    if (Array.isArray(ids) && ids.length > 0) {
      setArchiveRowIds(ids)
      setArchiveShow(true)
    }
  }
  const handleContextMenuScheduleChange = scheduleType => {
    if (!Array.isArray(scheduleOptions)) {
      console.error("scheduleOptions is not an array:", scheduleOptions)
      return
    }

    const selectedOption = scheduleOptions.find(
      opt => opt.name === scheduleType
    )
    if (selectedOption) {
      setSelectedScheduleOption(selectedOption)
      setIntertype(selectedOption.name)
      setInterviewPop(true) // Open the dialog

      if (selectedOption.code) {
        fetchSubTypes(selectedOption.code) // Fetch subtypes based on selected schedule ID
      }
    }
  }

  const getSelectedIds = () =>
    selectedCustomers.length > 0
      ? selectedCustomers?.map(c => c?.company_id)
      : selectedCompany
      ? [selectedCompany?.company_id]
      : []

const menuModel = isStatusActive ? [
    ...(selectedCustomers?.length <= 1
      ? [
          {
            label: "View",
            icon: "pi pi-fw pi-eye",
            visible: viewPermission,
            command: () => {
              const company =
                selectedCustomers?.length === 1
                  ? selectedCustomers[0]
                  : selectedCompany
              if (company) {
                const companyId = company?.company_id
                geteditvaluescondidates(companyId)
                setVisibleViewRight(true)
                fetchCompanyCandidates(companyId)
                fetchCompanyContacts(companyId)
                fetchCompanyHistory(companyId)
                fetchActivities(companyId)
                fetchPipelineData(companyId)
                fetchCompanyNotes(companyId)
                fetchCompanyDocuments(companyId)
                handleAddNotes()
              }
            },
          },
        ]
      : []),
    ...(selectedCustomers.length <= 1
      ? [
          {
            label: "Edit",
            icon: "pi pi-fw pi-pencil",
            visible: editPermission,
            command: () => {
              const company =
                selectedCustomers.length === 1
                  ? selectedCustomers[0]
                  : selectedCompany
              handleEditCompany(company)
            },
          },
        ]
      : []),

    param === "archived_only=true"
      ? {
          label: "Unarchive",
          icon: "pi pi-undo",
          command: () => handleUnarchive(getSelectedIds()),
        }
      : {
          label: "Archive",
          icon: "pi pi-check-circle",
          command: () => handleUnarchive(getSelectedIds()),
        },

    {
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      visible: deletePermission,
      command: () => {
        setDeleteRowID(getSelectedIds())
        setSmShow(true)
      },
    },
    {
      label: "Schedule",
      icon: "pi pi-calendar-clock",
      items: [
        {
          label: "Interview",
          icon: "pi pi-calendar-plus",
          command: () => handleContextMenuScheduleChange("Interview"),
        },
        {
          label: "Call",
          icon: "pi pi-phone",
          command: () => handleContextMenuScheduleChange("Call"),
        },
        {
          label: "Meeting",
          icon: "pi pi-users",
          command: () => handleContextMenuScheduleChange("Meeting"),
        },
        {
          label: "Task",
          icon: "pi pi-list",
          command: () => handleContextMenuScheduleChange("Task"),
        },
        {
          label: "Event",
          icon: "pi pi-calendar-clock",
          command: () => handleContextMenuScheduleChange("Event"),
        },
        {
          label: "Other",
          icon: "pi pi-ellipsis-h",
          command: () => handleContextMenuScheduleChange("Other"),
        },
      ],
    },
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        {
          label: "Attachments",
          icon: "pi pi-link",
          command: () => moreACContactsRef.current?.openAttachments(),
        },
        {
          label: "Change Status",
          icon: "pi pi-sync",
          command: () => moreACContactsRef.current?.openChangeStatus(),
        },
      ],
    },
    {
      label: "Company Notes",
      icon: "pi pi-clipboard",
      command: () => {
        setTimeout(() => {
          if (selectedCustomers.length > 0) {
            notesContactRef1.current?.openLinkJobModal()
          } else {
            notesContactRef.current?.openLinkJobModal()
          }
        }, 0)
      },
    },
    {
      label: "Export",
      icon: "pi pi-file-export",
      command: () => exportCSVBtn(true),
    },
    {
      label: "Clear Search",
      icon: "pi pi-sync",
      command: () => handleClearSearchCompanies(),
    },
  ] : [
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        {
          label: "Change Status",
          icon: "pi pi-sync",
          command: () => moreACContactsRef.current?.openChangeStatus(),
        },
      ],
    },
  ]

const fetchDocumentTypes = async () => {
  try {
    const response = await axios.get("/api/v1/get-all-document-type/")
    setDocumentTypes(
      (response.data?.results || []).map(dt => ({
        label: dt.value, // name
        value: dt.value, // value is the name, not id
        id: dt.id,       // keep id if you need it elsewhere
      }))
    )
  } catch (error) {
    setDocumentTypes([])
  }
}

useEffect(() => {
  fetchDocumentTypes()
}, [])

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          <div className="page-title-box">
            <Row className="align-items-center pt-3 pb-3 breadcrumb-card action-items">
              <Col xxl={9} xl={12} lg={12} md={12} sm={12}>
                              <div style={{ display: "inline-block", marginRight: "10px", minWidth: "180px" }}>
                <Dropdown
                  value={selectedCompanyStatus}
                  options={companyStatusOptions}
                  onChange={e => setSelectedCompanyStatus(e.value)}
                  optionLabel="label"
                  placeholder="Select Company Status"
                  className="w-full"
                />
              </div>
                {showesitSelecticon ? (
                  <button
                    type="button"
                    className="btn btn-secondary import-res-btn  ms-1 mainbtn me-1"
                  >
                    <i className="fa-regular fa-user me-1"></i>
                    {selectedEmployees} {selectedEmployees ? "Selected" : ""}
                  </button>
                ) : (
                  ""
                )}
               {isStatusActive && (
                <>
                {showesitSelect && addPermission ? (
                  <button
                    type="button"
                    className="btn btn-secondary import-res-btn md:w-10rem me-1"
                    onClick={() => {
                      reset()
                       setGroupItem([]);
  setSelectedCategoryKey(null);
  setSelectedGroupKey(null);
  setcompanysize(null); // clear company size
  setIndustry(null);    // (optional) clear industry
  dispatch(setCompanySidebarVisible(true));
  setAddress("");
  setisEdited(false);
  setstartyear(null);
  setWebsite("");
  setSelectedUserId(null);
  setSelectedCategoryNode(null)
          setSelectedGroupNode(null)
                    }}
                  >
                    <i class="pi pi-building mr-1"></i> Add a Company
                  </button>
                ) : (
                  ""
                )}

                {selectedCustomers.length > 0 ? (
                  showIconsSelect ? (
                    <>
                      {deletePermission && (
                        <>
                          <Tooltip
                            target=".delete"
                            content="Delete"
                            position="bottom"
                            style={{ marginTop: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 delete"
                            onClick={() => {
                              getCandidateIds()
                              setSmShow(true)
                            }}
                          >
                            <i className="pi pi-trash"></i>
                          </button>
                        </>
                      )}

                      {param === "archived_only=true" ? (
                        <>
                          <Tooltip
                            target=".unarchived"
                            content="Unarchive"
                            position="top"
                            style={{ marginBottom: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 unarchived"
                            onClick={handleArchiveUnarchiveClick}
                            disabled={archiveLoading}
                          >
                            <i className="pi pi-undo"></i>
                          </button>
                        </>
                      ) : (
                        <>
                          <Tooltip
                            target=".archived"
                            content="Archive"
                            position="top"
                            style={{ marginBottom: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 archived"
                            onClick={handleArchiveUnarchiveClick}
                            disabled={archiveLoading}
                          >
                            <i className="pi pi-check-circle"></i>
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {viewPermission && (
                        <>
                          <Tooltip
                            target=".view"
                            content="View"
                            position="bottom"
                            style={{ marginTop: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 view"
                            onClick={() => {
                              geteditvaluescondidates(
                                selectedCustomers[0].company_id
                              )
                              setVisibleViewRight(true)
                            }}
                          >
                            <i className="pi pi-eye"></i>
                          </button>
                        </>
                      )}

                      {editPermission && (
                        <>
                          <Tooltip
                            target=".edit"
                            content="Edit"
                            position="top"
                            style={{ marginBottom: "5px" }}
                          />
                          <Link
                            to={`/companies-editform?company_id=${selectedCustomers[0].company_id}`}
                          >
                            <button
                              type="button"
                              className="btn btn-light icons-btn ms-1 edit"
                              onClick={() => {
                                onloadcompany(selectedCustomers[0])
                                setisEdited(true)
                                setEditId(selectedCustomers[0].company_id)
                                dispatch(setCompanySidebarVisible(true))
                              }}
                            >
                              <i className="pi pi-pencil"></i>
                            </button>
                          </Link>
                        </>
                      )}

                      {deletePermission && (
                        <>
                          <Tooltip
                            target=".delete"
                            content="Delete"
                            position="bottom"
                            style={{ marginTop: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 delete"
                            onClick={() => {
                              setDeleteRowID(selectedCustomers[0].company_id)
                              setSmShow(true)
                            }}
                          >
                            <i className="pi pi-trash"></i>
                          </button>
                        </>
                      )}

                      {param === "archived_only=true" ? (
                        <>
                          <Tooltip
                            target=".unarchived"
                            content="Unarchive"
                            position="top"
                            style={{ marginBottom: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 unarchived"
                            onClick={handleArchiveUnarchiveClick}
                            disabled={archiveLoading}
                          >
                            <i className="pi pi-undo"></i>
                          </button>
                        </>
                      ) : (
                        <>
                          <Tooltip
                            target=".archived"
                            content="Archive"
                            position="top"
                            style={{ marginBottom: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-light icons-btn ms-1 archived"
                            onClick={handleArchiveUnarchiveClick}
                            disabled={archiveLoading}
                          >
                            <i className="pi pi-check-circle"></i>
                          </button>
                        </>
                      )}
                    </>
                  )
                ) : null}

                <span className="drop-ac">
                 {/* <button
                   type="button"
                   className="btn btn-secondary import-res-btn  ms-1  me-1"
                 >
                   Submit Candidate
                 </button> */}

                 {selectedCustomers.length === 1 && <AddContact selectedCompany={selectedCustomers[0]} />}

                 <CascadeSelect
                    value={selectedScheduleOption}
                    onChange={handleScheduleChange}
                    options={scheduleOptions}
                    optionLabel="name"
                    optionGroupLabel="name"
                    className="md:w-10rem me-1"
                    optionGroupChildren={["subItems"]}
                    breakpoint="767px"
                    placeholder="Schedule"
                  />
                  </span>
                  </>)}
                  <span className="drop-ac">
                  <MoreACcompanies
                    setSelectedCustomers={setSelectedCustomers}
                    ref={moreACContactsRef}
                    getCompanydata={getCompanydata}
                    type={type}
                    param={param}
                    first={first}
                    rows={rows}
                    selectedCustomers={selectedCustomers}
                    onStatusChanged={handleStatusChanged}
                    isStatusActive={isStatusActive}
                  />
                </span>
              </Col>

              <Col xxl={3} xl={12} lg={12} sm={12}>
                <div className="clr-icons">
                  {/* {type !== "task-list" && type !== "activity_log" ? ( */}
                  {selectedCustomers.length > 0 ? (
                    <>
                      {addPermission && (
                        <NotesCompanies1
                          ref={notesContactRef1}
                          selectedCustomers={selectedCustomers}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {addPermission && (
                        <NotesCompanies
                          ref={notesContactRef}
                          customers={customers}
                        />
                      )}
                    </>
                  )}
                  {/* ) : null} */}
                  {/* {selectedCustomers.length > 0 ? <NotesCompanies1 selectedCustomers={selectedCustomers} /> : <NotesCompanies customers={customers} />} */}

                  <Tooltip
                    target=".export"
                    content="Export"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 export"
                    onClick={() => setImportCsvIcons(!importCsvIcons)}
                  >
                    <i className="pi pi-file-export"></i>
                  </button>

                  {importCsvIcons && <span>{headerBtn}</span>}

                  <Tooltip
                    target=".clear"
                    content="Clear Search"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 clear"
                    Tooltip="Clear Search"
                    onClick={handleClearSearchCompanies}
                  >
                    <i className="pi pi-sync"></i>
                  </button>
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                <section className="allactjobs-table">
                  <ContextMenu
                    model={menuModel}
                    ref={cm}
                    onHide={() => setSelectedCompany(null)}
                  />

                  <div className="card1 mt-4 mb-4 actjobsumtable">
                    {!statusLoaded || dataLoading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: 300 }}
                      >
                        <ProgressSpinner />
                      </div>
                    ) : type === "activity_log" ? (
                      <DataTable
                        ref={dt}
                        value={customers}
                        rows={rows}
                        first={first}
                        totalRecords={totalRecords}
                        onPage={onPageChange}
                        loading={loading}
                        onSelectionChange={onSelectionChange}
                        selectionMode="multiple"
                        filters={filtersActivityLog}
                        filterDisplay="row"
                        globalFilterFields={[
                          "event_type",
                          "event_sub_type",
                          "event_priority",
                          "subject",
                          "status",
                          "start_date_time",
                          // 'candidate.first_name',
                          "company.company_name",
                          "job.job_title",
                          "company.mobile_phone",
                          "company.category_name",
                          "company.groups_name",
                          "company.created_at",
                          "company.updated_at",
                          "created_by_name",
                        ]}
                        scrollable
                        selection={selectedCustomers}
                        resizableColumns
                        reorderableColumns
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        emptyMessage="No activities found."
                        onContextMenu={e => {
                          cm.current.show(e.originalEvent) // Show the context menu
                          setSelectedCompany(e.data)
                        }}
                        contextMenuSelection={selectedCompany}
                        onContextMenuSelectionChange={e =>
                          setSelectedCompany(e.value)
                        }
                      >
                        <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        />
                        <Column
                          field="event_type"
                          header="Type"
                          sortable
                          filter
                          filterPlaceholder="Search by Type"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="event_sub_type"
                          header="Sub Type"
                          sortable
                          filter
                          filterPlaceholder="Search by Sub Type"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="event_priority"
                          header="Priority"
                          sortable
                          filter
                          filterPlaceholder="Search by Priority"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="subject"
                          header="Subject"
                          sortable
                          filter
                          filterPlaceholder="Search by Subject"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="status"
                          header="Status"
                          sortable
                          filter
                          filterPlaceholder="Search by Status"
                          style={{ minWidth: "10rem" }}
                          body={rowData => rowData.status || "N/A"}
                        />
                        <Column
                          field="start_date_time"
                          header="Start Date Time"
                          sortable
                          filter
                          filterPlaceholder="Search by Start Date Time"
                          style={{ minWidth: "12rem" }}
                          body={rowData =>
                            `${rowData.start_date} ${rowData.start_time.slice(
                              0,
                              5
                            )}`
                          }
                        />
                        {/* <Column
                field="candidate.first_name"
                header="Full Name"
                sortable
                filter
                filterPlaceholder="Search by Full Name"
                style={{ minWidth: '10rem' }}
                body={(rowData) => `${rowData.candidate.first_name} ${rowData.candidate.last_name}`.trim() || 'N/A'}
            /> */}
                        <Column
                          field="company.company_name"
                          header="Company Name"
                          sortable
                          filter
                          filterPlaceholder="Search by Company Name"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="job.job_title"
                          header="Job Title"
                          sortable
                          filter
                          filterPlaceholder="Search by Job Title"
                          style={{ minWidth: "12rem" }}
                        />
                        <Column
                          field="company.mobile_phone"
                          header="Phone"
                          sortable
                          filter
                          filterPlaceholder="Search by Phone"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.mobile_phone || "N/A"
                          }
                        />
                        <Column
                          field="company.category_name"
                          header="Categories"
                          sortable
                          filter
                          filterPlaceholder="Search by Categories"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.category_name || "N/A"
                          }
                        />
                        <Column
                          field="company.groups_name"
                          header="Groups"
                          sortable
                          filter
                          filterPlaceholder="Search by Groups"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.groups_name || "N/A"
                          }
                        />
                        <Column
                          field="company.created_at"
                          header="Create Date"
                          sortable
                          filter
                          filterPlaceholder="Search by Create Date"
                          style={{ minWidth: "12rem" }}
                          body={rowData =>
                            rowData.company?.created_at
                              ? moment(rowData.company?.created_at).format(
                                  "YYYY-MM-DD"
                                )
                              : "N/A"
                          }
                        />
                        <Column
                          field="company.updated_at"
                          header="Edit Date"
                          sortable
                          filter
                          filterPlaceholder="Search by Edit Date"
                          style={{ minWidth: "12rem" }}
                          body={rowData =>
                            rowData.company?.updated_at
                              ? moment(rowData.company?.updated_at).format(
                                  "YYYY-MM-DD"
                                )
                              : "N/A"
                          }
                        />
                        <Column
                          field="created_by_name"
                          header="Created By"
                          sortable
                          filter
                          filterPlaceholder="Search by Created By"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.created_by_name || "N/A"
                          }
                        />
                      </DataTable>
                    ) : type === "task-list" ? (
                      <DataTable
                        ref={dt}
                        value={customers}
                        rows={rows}
                        first={first}
                        totalRecords={totalRecords}
                        onPage={onPageChange}
                        loading={loading}
                        onSelectionChange={onSelectionChange}
                        selectionMode="multiple"
                        filters={filtersTaskList}
                        filterDisplay="row"
                        emptyMessage="No Company Tasks Found"
                        scrollable
                        selection={selectedCustomers}
                        resizableColumns
                        reorderableColumns
                        onContextMenu={e => {
                          cm.current.show(e.originalEvent) // Show the context menu
                          setSelectedCompany(e.data)
                        }}
                        contextMenuSelection={selectedCompany}
                        onContextMenuSelectionChange={e =>
                          setSelectedCompany(e.value)
                        }
                      >
                        <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        />
                        <Column
                          field="event_type"
                          header="Type"
                          sortable
                          filter
                          filterPlaceholder="Search by EventType"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="event_sub_type"
                          header="Sub-Type"
                          sortable
                          filter
                          filterPlaceholder="Search by SubType"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="event_priority"
                          header="Priority"
                          sortable
                          filter
                          filterPlaceholder="Search by Priority"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="subject"
                          header="Subject"
                          sortable
                          filter
                          filterPlaceholder="Search by Subject"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="status"
                          header="Status"
                          sortable
                          filter
                          filterPlaceholder="Search by Status"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="start_date_time"
                          header="Start Date Time"
                          sortable
                          filter
                          filterPlaceholder="Search by Start Date Time"
                          style={{ minWidth: "12rem" }}
                          body={rowData =>
                            `${rowData.start_date} ${rowData.start_time.slice(
                              0,
                              5
                            )}`
                          }
                        />
                        {/* <Column
                field="candidate.first_name"
                header="Full Name"
                sortable
                filter
                filterPlaceholder="Search by Full Name"
                style={{ minWidth: '10rem' }}
                body={(rowData) => `${rowData.candidate.first_name} ${rowData.candidate.last_name}`.trim() || 'N/A'}
            /> */}
                        <Column
                          field="company.company_name"
                          header="Company Name"
                          sortable
                          filter
                          filterPlaceholder="Search by Company Name"
                          style={{ minWidth: "10rem" }}
                        />
                        <Column
                          field="job.job_title"
                          header="Job Title"
                          sortable
                          filter
                          filterPlaceholder="Search by Job Title"
                          style={{ minWidth: "12rem" }}
                        />
                        <Column
                          field="company.mobile_phone"
                          header="Phone"
                          sortable
                          filter
                          filterPlaceholder="Search by Phone"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.mobile_phone || "N/A"
                          }
                        />
                        <Column
                          field="company.category_name"
                          header="Categories"
                          sortable
                          filter
                          filterPlaceholder="Search by Categories"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.category_name || "N/A"
                          }
                        />
                        <Column
                          field="company.groups_name"
                          header="Groups"
                          sortable
                          filter
                          filterPlaceholder="Search by Groups"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.groups_name || "N/A"
                          }
                        />
                        <Column
                          field="company.created_at"
                          header="Create Date"
                          sortable
                          filter
                          filterPlaceholder="Search by Create Date"
                          style={{ minWidth: "12rem" }}
                          body={rowData =>
                            rowData.company?.created_at
                              ? moment(rowData.company?.created_at).format(
                                  "YYYY-MM-DD"
                                )
                              : "N/A"
                          }
                        />
                        <Column
                          field="company.updated_at"
                          header="Edit Date"
                          sortable
                          filter
                          filterPlaceholder="Search by Edit Date"
                          style={{ minWidth: "12rem" }}
                          body={rowData =>
                            rowData.company?.updated_at
                              ? moment(rowData.company?.updated_at).format(
                                  "YYYY-MM-DD"
                                )
                              : "N/A"
                          }
                        />
                        <Column
                          field="created_by_name"
                          header="Created By"
                          sortable
                          filter
                          filterPlaceholder="Search by Created By"
                          style={{ minWidth: "10rem" }}
                          body={rowData =>
                            rowData.company?.created_by_name || "N/A"
                          }
                        />
                      </DataTable>
                    ) : (
                      <DataTable
                        ref={dt}
                        value={customers}
                        first={first}
                        rows={rows}
                        totalRecords={totalRecords}
                        onPage={onPageChange}
                        loading={loading}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 50, totalRecords]} // Dynamic row options including "All"
                        dataKey="company_id"
                        filters={filters}
                        onFilter={e => {
                          setFilters(e.filters);
                          if (debounceTimeout.current) {
                            clearTimeout(debounceTimeout.current);
                          }
                          debounceTimeout.current = setTimeout(() => {
                            getCompanydata(Math.floor(first / rows) + 1, type, param, selectedCompanyStatus, e.filters);
                          }, 300);
                        }}
                        filterDisplay="row"
                        scrollable
                        emptyMessage="No Companies found."
                        selectionMode="multiple"
                        selection={selectedCustomers}
                        onSelectionChange={onSelectionChange}
                        reorderableRows
                        onRowReorder={onRowReorder}
                        rowGroupMode="rowspan"
                        rowClassName="row-bottom-color" // Apply custom row style
                        editMode="cell"
                        onContextMenuSelectionChange={e =>
                          setSelectedCompany(e.value)
                        }
                        contextMenuSelection={selectedCompany}
                        onContextMenu={e => {
                          cm.current.show(e.originalEvent)
                          setSelectedCompany(e.data)
                        }}
                        resizableColumns // Enable resizable columns
                        columnResizeMode="expand" // Choose between "fit" or "expand"
                      >
                        <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        />
                        <Column
                          field="company_name"
                          frozen
                          sortable
                          header="Company"
                          filter
                          filterPlaceholder="Search by company"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.company_name?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'company_name')}
                          //         placeholder="Search by company"
                          //     />
                          // )}
                        />
                        <Column
                          field="website"
                          sortable
                          header="Website"
                          filter
                          filterPlaceholder="Search by website"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.website?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'website')}
                          //         placeholder="Search by website"
                          //     />
                          // )}
                        />
                        <Column
                          field="industry_name"
                          sortable
                          header="Industry"
                          filter
                          filterPlaceholder="Search by industry"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.industry_name?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'industry_name')}
                          //         placeholder="Search by industry"
                          //     />
                          // )}
                        />
                        <Column
                          field="company_size"
                          sortable
                          header="Company Size"
                          filter
                          filterPlaceholder="Search by size"
                          style={{ minWidth: "15rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.company_size?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'company_size')}
                          //         placeholder="Search by size"
                          //     />
                          // )}
                        />
                        <Column
                          field="founded_year"
                          sortable
                          header="Year Founded"
                          filter
                          filterPlaceholder="Search by year"
                          style={{ minWidth: "15rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.founded_year?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'founded_year')}
                          //         placeholder="Search by year"
                          //     />
                          // )}
                        />
                        <Column
                          field="status"
                          sortable
                          header="Status"
                          filter
                          filterPlaceholder="Search by Status"
                          style={{ minWidth: "15rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.status?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'status')}
                          //         placeholder="Search by Status"
                          //     />
                          // )}
                        />
                        <Column
                          field="company_email"
                          sortable
                          header="Email"
                          filter
                          filterPlaceholder="Search by email"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.company_email?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'company_email')}
                          //         placeholder="Search by email"
                          //     />
                          // )}
                        />
                        <Column
                          field="mobile_phone"
                          sortable
                          header="Mobile Phone"
                          filter
                          filterPlaceholder="Search by phone"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.mobile_phone?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'mobile_phone')}
                          //         placeholder="Search by phone"
                          //     />
                          // )}
                        />
                        <Column
                          field="street_address"
                          sortable
                          header="Address"
                          filter
                          filterPlaceholder="Search by address"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.street_address?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'street_address')}
                          //         placeholder="Search by address"
                          //     />
                          // )}
                          body={rowData => (
                            <span>
                              {rowData.street_address}
                              {rowData.street_address_line_2 &&
                                `, ${rowData.street_address_line_2}`}
                            </span>
                          )}
                        />
                        <Column
                          field="category_name"
                          sortable
                          header="Category"
                          filter
                          filterPlaceholder="Search by category"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.category_name?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'category_name')}
                          //         placeholder="Search by category"
                          //     />
                          // )}
                        />
                        <Column
                          field="groups_name"
                          sortable
                          header="Group"
                          filter
                          filterPlaceholder="Search by group"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.groups_name?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'groups_name')}
                          //         placeholder="Search by group"
                          //     />
                          // )}
                        />
                        {/* 
                      <Column
                          field="user_ids"
                          sortable
                          header="User IDs"
                          filter
                          filterPlaceholder="Search by user ID"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.user_ids?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'user_ids')}
                          //         placeholder="Search by user ID"
                          //     />
                          // )}
                        /> */}

                        <Column
                          field="created_by_name"
                          header="Created By"
                          sortable
                          filter
                          filterPlaceholder="Search by creator"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.created_by_name?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'created_by_name')}
                          //         placeholder="Search by creator"
                          //     />
                          // )}
                        />
                        <Column
                          field="last_activity_date"
                          header="Last Activity Date"
                          body={rowData =>
                            rowData.last_activity_date
                              ? moment(rowData.last_activity_date).format(
                                  "YYYY-MM-DD"
                                )
                              : ""
                          }
                          sortable
                          filter
                          filterPlaceholder="Search by activity date"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.last_activity_date?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'last_activity_date')}
                          //         placeholder="Search by activity date"
                          //     />
                          // )}
                        />
                        <Column
                          field="created_at"
                          header="Create Date"
                          body={rowData =>
                            rowData.created_at
                              ? moment(rowData.created_at).format("YYYY-MM-DD")
                              : ""
                          }
                          sortable
                          filter
                          filterPlaceholder="Search by Created date"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.created_at?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'created_at')}
                          //         placeholder="Search by Create date"
                          //     />
                          // )}
                        />
                        <Column
                          field="updated_at"
                          header="Edit Date"
                          body={rowData =>
                            rowData.updated_at
                              ? moment(rowData.updated_at).format("YYYY-MM-DD")
                              : ""
                          }
                          sortable
                          filter
                          filterPlaceholder="Search by Update date"
                          style={{ minWidth: "12rem" }}
                          // filterElement={(options) => (
                          //     <InputText
                          //         value={filters.updated_at?.value || ''}
                          //         onChange={(e) => onInputChange(e, 'updated_at')}
                          //         placeholder="Search by Update date"
                          //     />
                          // )}
                        />
                      </DataTable>
                    )}
                  </div>
                </section>
              </Col>
            </Row>

            {/* Side bar start */}
            <Row>
              <Col lg={12}>
                <Sidebar
                  visible={companySidebarVisible}
                  position="right"
                  className="sidebar"
                  onHide={() => {
                    if (!isGeneratingInfo) {
                      dispatch(setCompanySidebarVisible(false))
                    }
                  }}
                  closable={!isGeneratingInfo}
                >
                  <div className="sidebar-header">
                    <h3>Create a Company</h3>
                    <div className="d-flex align-items-center">
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn"
                        disabled={isGeneratingInfo}
                        onClick={() => {
                          if (!isGeneratingInfo) {
                            reset()
                            dispatch(setCompanySidebarVisible(false))
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="card sidebardetails">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Row className="mb-2">
                        <Col lg={6}>
  <div className="p-field" style={{ position: 'relative' }}>
    <label htmlFor="company">
      Company <span className="text-danger">*</span>
    </label>
    <InputText
      aria-label="Default select example"
      {...register("comapany", {
        required: "This field is required",
        pattern: {
          value: /^[a-zA-Z0-9][a-zA-Z0-9\s&\-.]*$/,
          message: "Please enter a valid company name",
        },
        minLength: {
          value: 2,
          message: "Company name must be at least 2 characters long",
        },
        maxLength: {
          value: 100,
          message: "Company name cannot exceed 100 characters",
        },
      })}
      onKeyUp={() => {
        trigger("comapany")
      }}
      onChange={(e) => {
        setValue("comapany", e.target.value)
        handleCompanyNameChange(e.target.value)
      }}
      style={{ paddingRight: isGeneratingInfo ? '2.5rem' : '1rem' }}
    />
    {isGeneratingInfo && (
      <ProgressSpinner
        style={{
          position: 'absolute',
          right: '10px',
          top: '65%',
          transform: 'translateY(-50%)',
          width: '16px',
          height: '16px'
        }}
      />
    )}
    {errors.comapany && (
      <small
        id="emailHelp"
        className="form-text text-danger"
      >
        {errors.comapany.message}
      </small>
    )}
  </div>
</Col>

                        <Col lg={6}>
                          <div className="p-field" style={{ position: 'relative' }}>
                            <label htmlFor="website">Website</label>
                            <InputText
                              placeholder="Enter website URL"
                              {...register("website", {
                                // required: "This field is required",
                                pattern: {
                                  value:
                                    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+)(\.[a-zA-Z]{2,})(\/.*)?$/,
                                  message: "Please enter valid website.",
                                },
                              })}
                              onKeyUp={e => {
                                trigger("website")
                              }}
                              onChange={(e) => {
                                setValue("website", e.target.value)
                                handleWebsiteChange(e.target.value)
                              }}
                              style={{ paddingRight: isGeneratingInfo ? '2.5rem' : '1rem' }}
                            />
                            {isGeneratingInfo && (
                              <ProgressSpinner
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '65%',
                                  transform: 'translateY(-50%)',
                                  width: '16px',
                                  height: '16px'
                                }}
                              />
                            )}
                            {errors.website && (
                              <small
                                id="phoneNoHelp"
                                className="form-text text-danger"
                              >
                                {errors.website.message}
                              </small>
                            )}
                          </div>
                          <div></div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="work-email">Email</label>
                            <InputText
                              placeholder="Enter email"
                              {...register("personal_email", {
                                // required: "Please enter  Email",
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z.-]{2,}\.+[A-Z]{2,}$/i,
                                  message: "Please enter valid Email", // JS only: <p>error message</p> TS only support string
                                },
                                onChange: event =>
                                  (event.target.value =
                                    event.target.value.toLowerCase()),
                              })}
                            />
                            {errors.personal_email && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.personal_email.message}
                              </small>
                            )}
                          </div>
                        </Col>

                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="phoneNumber">Phone Number</label>
                            <InputText
                              placeholder="Enter phone number"
                              {...register("phone", {
                                // required: "This field is required",
                                pattern: {
                                  value:
                                    /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/,
                                  message:
                                    "Please enter a valid mobile number.",
                                },
                                minLength: {
                                  value: 10,
                                  message:
                                    "Please enter Min and Max 10 digits ",
                                },
                                maxLength: {
                                  value: 10,
                                  message:
                                    "Please enter Min and Max 10 digits ",
                                },
                              })}
                              onKeyUp={e => {
                                trigger("phone")
                              }}
                            />
                            {errors.phone && (
                              <small
                                id="phoneNoHelp"
                                className="form-text text-danger"
                              >
                                {errors.phone.message}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={12}>
                          <div
                            className="p-field companie-add"
                            style={{ position: "relative" }}
                          >
                            <label htmlFor="address">Address</label>
                            <InputTextarea
                              id="address"
                              value={address}
                              readOnly
                              onChange={e => setAddress(e.target.value)}
                              style={{ paddingRight: "2rem" }}
                              rows={3}
                              cols={30}
                            />
                            <i
                              className="pi pi-pencil"
                              style={{
                                position: "absolute",
                                right: "20px",
                                top: "70%",
                                transform: "translateY(-50%)",
                                color: "#6c757d",
                                cursor: "pointer",
                              }}
                              onClick={() => setVisible(true)}
                            ></i>
                            <Dialog
                              header="Edit Address"
                              className="address-popup"
                              visible={visible}
                              onHide={handleDialogHide} // Handle cancel/close
                              style={{ width: "30vw" }}
                              breakpoints={{
                                "960px": "75vw",
                                "641px": "100vw",
                              }}
                            >
                              <div className="card sidebardetails">
                                <form>
                                  <Row className="mb-3">
                                    <Col lg={6}>
                                      <div className="p-field">
                                        <label htmlFor="street1">
                                          Street 1
                                        </label>
                                        <InputText
                                          id="street1"
                                          value={street1}
                                          onChange={e =>
                                            setStreet1(e.target.value)
                                          }
                                          placeholder="Enter Street 1"
                                          className="w-full activejobdrop"
                                        />
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <label htmlFor="street2">Street 2</label>
                                      <InputText
                                        id="street2"
                                        value={street2}
                                        onChange={e =>
                                          setStreet2(e.target.value)
                                        }
                                        placeholder="Enter Street 2 (Optional)"
                                        className="w-full activejobdrop"
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-3">
                                    <Col lg={6}>
                                      <label htmlFor="country">Country</label>
                                      <Dropdown
                                        value={selectedCountry}
                                        onChange={e =>
                                          setSelectedCountry(e.value)
                                        }
                                        options={addCountries}
                                        optionLabel="name"
                                        filter
                                        filterPlaceholder="Search Country"
                                        className="w-full activejobdrop"
                                        placeholder="Enter country details..."
                                      />
                                    </Col>
                                    <Col lg={6}>
                                      <label htmlFor="state">State</label>
                                      <Dropdown
                                        id="state"
                                        value={selectedState}
                                        onChange={e =>
                                          setSelectedState(e.value)
                                        }
                                        options={addStates}
                                        optionLabel="name"
                                        filter
                                        filterPlaceholder="Search State"
                                        className="w-full activejobdrop"
                                        placeholder="Enter state details..."
                                      />
                                    </Col>
                                  </Row>
                                  <Row className="mb-3">
                                    <Col lg={6}>
                                      <label htmlFor="city">City</label>
                                      <Dropdown
                                        id="city"
                                        value={selectedCity}
                                        onChange={e => setSelectedCity(e.value)}
                                        options={addCities}
                                        optionLabel="name"
                                        filter
                                        filterPlaceholder="Search City"
                                        className="w-full activejobdrop"
                                        placeholder="Enter city details..."
                                      />
                                    </Col>
                                    <Col lg={6}>
                                      <label htmlFor="postalCode">
                                        Postal Code
                                      </label>
                                      <InputText
                                        id="postalCode"
                                        value={postalCode}
                                        onChange={e => {
                                          const value = e.target.value
                                          if (
                                            value === "" ||
                                            /^\d{0,6}$/.test(value)
                                          ) {
                                            // Allows empty input or up to 6 digits
                                            setPostalCode(value)
                                            setErrorMessage("")
                                          } else {
                                            setErrorMessage(
                                              "Please enter only numbers (up to 6 digits)"
                                            )
                                          }
                                        }}
                                        placeholder="Enter Postal Code"
                                        className={`w-full activejobdrop ${
                                          errorMessage ? "p-invalid" : ""
                                        }`}
                                        maxLength={6}
                                      />
                                      {errorMessage && (
                                        <small className="p-error">
                                          {errorMessage}
                                        </small>
                                      )}
                                    </Col>
                                  </Row>

                                  <Row className="mb-3">
                                    <Col lg={12}>
                                      <label htmlFor="label">Label</label>
                                      <Dropdown
                                        id="label"
                                        value={selectedLabel}
                                        onChange={e =>
                                          setSelectedLabel(e.value)
                                        }
                                        options={labels}
                                        optionLabel="name"
                                        placeholder={
                                          labels.length
                                            ? "Select Label"
                                            : "No labels available"
                                        }
                                        className="w-full activejobdrop"
                                        disabled={!labels.length}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Button
                                        type="button"
                                        color="primary"
                                        className="btn btn-primary waves-light me-2 sidebarbtn"
                                        onClick={handleOkClick} // Handle OK
                                      >
                                        <i className="pi pi-check me-1"></i> Ok
                                      </Button>
                                    </Col>
                                  </Row>
                                </form>
                              </div>
                            </Dialog>
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="yearFounded">Year Founded</label>
                            <DatePicker
                              id="EmpMang_YearDatePicker"
                              className="form-select Mukta_Font SelectYearDatePicker"
                              selected={startyear}
                              onChange={date => {
                                setstartyear(date)
                              }}
                              showYearPicker
                              dateFormat="yyyy"
                              maxDate={new Date()}
                              placeholderText="Please select a Year"
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="p-field">
                            <label>Specialties</label>
                            <InputText
                              placeholder="Enter specialties"
                              className="w-full activejobdrop"
                              {...register("Specialties", {
                                // required: "This field is required",
                                // pattern: {
                                //     value: /^[a-zA-Z_ ]*$/,
                                //     message:
                                //         "Please enter valid Specialties ",
                                // },
                              })}
                              onKeyUp={() => {
                                trigger("Specialties")
                              }}
                            />
                            {/* {errors.Specialties && (<small id='emailHelp' className='form-text text-danger'>{errors.Specialties.message}</small>)} */}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="industry">Industry</label>
                            <Dropdown
                              id="industry"
                              value={industry}
                              onChange={e => setIndustry(e.value)}
                              options={industryview}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              filterPlaceholder="Search Industry"
                              className="w-full activejobdrop"
                              placeholder="Select industry..."
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="companySize">Company Size</label>
                            <Dropdown
                              value={companysize}
                              onChange={e => setcompanysize(e.value)}
                              options={companysizeview}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              filterPlaceholder="Search Industry"
                              className="w-full activejobdrop"
                              placeholder="Select industry..."
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={12}>
                          <div className="p-field">
                            <label htmlFor="jobType">Overview</label>
                            <InputTextarea
                              autoResize
                              rows={5}
                              cols={40}
                              placeholder="Company overview will appear here"
                              {...register("Overview", {
                                // required: "This field is required",
                                // pattern: {
                                //     value: /^[a-zA-Z_ ]*$/,
                                //     message:
                                //         "Please enter valid Specialties ",
                                // },
                              })}
                              onKeyUp={() => {
                                trigger("Overview")
                              }}
                              className="w-full"
                            />
                            {/* {errors.Overview && (<small id='emailHelp' className='form-text text-danger'>{errors.Overview.message}</small>)} */}
                          </div>
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Categories</label>
                            <TreeSelect
                              value={selectedCategoryNode}
                              options={categoryNodes}
                              onChange={e => setSelectedCategoryNode(e.value)}
                              className="w-full"
                              placeholder="Select Category"
                              filter
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="company">Group</label>
                            <TreeSelect
                              value={selectedGroupNode}
                              options={groupNodes}
                              onChange={e => setSelectedGroupNode(e.value)}
                              className="w-full"
                              placeholder="Select Group"
                              filter
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="align-items-end mb-2">
                        <Col lg={6}>
                          <div className="p-field">
                            <label htmlFor="jobType">UserIDs</label>
                            <InputText
                              value={uniqueUserId}
                              readOnly
                              placeholder="Select a User ID"
                              className="w-full activejobdrop"
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="p-field">
                            <input
                              type="checkbox"
                              className="me-2"
                              {...register("relocation", {})}
                              checked={isPrivate}
                              onChange={(e) => {
                                trigger("relocation")
                                setIsPrivate(e.target.checked)
                              }}
                            />
                            <label htmlFor="jobType">Private</label>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        {loading && (
                          <div className="flex justify-content-center align-items-center mt-3">
                            <ProgressSpinner />
                          </div>
                        )}
                      </Row>

                      <Row>
                        <Col>
                          <Button
                            color="primary"
                            className="btn btn-primary  waves-light me-2 sidebarbtn"
                            disabled={loading || disable || isGeneratingInfo}
                          >
                            Create
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  </div>
                </Sidebar>
              </Col>
            </Row>
            {/* Side bar end */}
          </div>
        </Container>
      </div>

      <Modal
        size="md"
        show={smShow}
        onHide={() => setSmShow(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5 "> Delete</h1>
        </Modal.Header>
        <div className="text-center m-3 text-danger"> </div>
        <h4 className="text-center m-3">
          {" "}
          Are you sure you want to delete this Company{" "}
        </h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary m-1"
            onClick={() => setSmShow(false)}
          >
            Cancel
          </Button>
          <button className="btn btn-primary m-1" onClick={deleteHandler}>
            {" "}
            Delete{" "}
          </button>
        </div>
      </Modal>

      <Modal
        size="md"
        show={archiveShow}
        onHide={() => setArchiveShow(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5">
            {param === "archived_only=true" ? "Unarchive" : "Archive"}
          </h1>
        </Modal.Header>
        <div className="text-center m-3 text-warning"></div>
        <h4 className="text-center">
          Are you sure you want to{" "}
          {param === "archived_only=true" ? "unarchive" : "archive"}{" "}
          {archiveRowIds.length} company(ies)?
        </h4>
        <div className="text-center m-3">
          <Button
            className="btn btn-primary m-1"
            onClick={() => setArchiveShow(false)}
            disabled={archiveLoading}
          >
            Cancel
          </Button>
          <button
            className="btn btn-primary m-1"
            onClick={archiveUnarchiveHandler}
            disabled={archiveLoading}
          >
            {archiveLoading ? (
              <ProgressSpinner style={{ width: "20px", height: "20px" }} />
            ) : param === "archived_only=true" ? (
              "Unarchive"
            ) : (
              "Archive"
            )}
          </button>
        </div>
      </Modal>

      <Modal
        size="md"
        show={successAlert}
        onHide={() => setSuccessAlert(false)}
        className="text-center"
      >
        <Modal.Header closeButton>
          <h1 className="modal-title fs-5 "> Success</h1>
        </Modal.Header>
        <div className="text-center m-3"> </div>
        <h4 className="text-center">Delete Successfully</h4>
        <div className="text-center m-3">
          <button
            className="btn btn-primary"
            onClick={() => setSuccessAlert(false)}
          >
            {" "}
            OK{" "}
          </button>
        </div>
      </Modal>

      {/* Company Info Generation Loading Dialog */}
      <Dialog
        header={null}
        visible={isGeneratingInfo}
        closable={false}
        modal={true}
        style={{ width: '450px' }}
        className="loading-dialog"
        contentStyle={{ padding: '2rem', textAlign: 'center', backgroundColor: '#f8f9fa' }}
      >
        <div className="flex flex-column align-items-center">
          <div className="mb-3">
            <ProgressSpinner 
              style={{ 
                width: '60px', 
                height: '60px',
                '--pi-primary-color': '#007bff'
              }} 
              strokeWidth="4"
              animationDuration="1s"
            />
          </div>
          <h4 className="text-primary mb-2">Generating Company Overview</h4>
          <p className="text-center mb-2" style={{ color: '#6c757d' }}>
            Please wait while we fetch and generate the company information...
          </p>
          <div className="flex align-items-center mt-2">
            <i className="pi pi-info-circle mr-2" style={{ color: '#17a2b8' }}></i>
            <small className="text-muted">
              This process may take a few moments. Please do not close this window.
            </small>
          </div>
        </div>
      </Dialog>

      {/* Interview schedule start */}
      {selectedCustomers?.length > 0 ? (
        <Dialog
          header={`Appointment - ${
            selectedCustomers[0]?.company_name || ""
          } ${jobidsslectnames}`}
          visible={interviewPop}
          className="interview-popup"
          style={{ width: "50vw" }}
          onShow={resetDefaultDateTime}
          onHide={() => {
            setInterviewPop(false)
            setSelectedScheduleOption(null)
            resetForm()
          }}
        >
          <form onSubmit={e => e.preventDefault()}>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">Type</label>
                      <InputText disabled value={intertype} />
                    </div>
                  </Col>
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="subtype" className="block">
                        Sub-Type{" "}
                      </label>
                      <Dropdown
                        value={subtype}
                        onChange={e => {
                          setSubtype(e.value)
                          setFormErrors(prev => ({ ...prev, subtype: "" }))
                        }}
                        options={typeInterview}
                        optionLabel="name"
                        placeholder="Subtype"
                        className={`w-full search-option ${
                          formErrors.subtype ? "p-invalid" : ""
                        }`}
                      />
                      {/* {formErrors.subtype && <small className="p-error">{formErrors.subtype}</small>} */}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Start date
                          </label>
                          <Calendar
                            value={startdate}
                            dateFormat="yy-mm-dd"
                            onChange={e => {
                              setStartdate(e.value)

                              if (enddate && e.value && enddate <= e.value) {
                                setenddate(null) // Reset end date if invalid
                              }
                            }}
                            minDate={new Date()} // Allow today and future
                            showIcon
                          />
                          {/* <Calendar
                                                        value={startdate}
                                                        onChange={(e) => { setStartdate(e.value); setFormErrors(prev => ({ ...prev, startdate: '' })); }}
                                                        showIcon
                                                        minDate={new Date()}
                                                        className={formErrors.startdate ? 'p-invalid' : ''}
                                                    /> */}
                          {formErrors.startdate && (
                            <small className="p-error">
                              {formErrors.startdate}
                            </small>
                          )}
                        </div>
                      </Col>
                      <Col xl={6}>
                        <div className="p-field flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={starttime}
                            onChange={e => {
                              const selectedTime = e.value
                              setStarttime(selectedTime)
                              if (selectedTime) {
                                const newEndTime = new Date(
                                  selectedTime.getTime() + 30 * 60000
                                )
                                setendtime(newEndTime)
                                setFormErrors("")
                              }
                            }}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                          {/* <Calendar
                                                        value={starttime}
                                                        onChange={(e) => { setStarttime(e.value); setFormErrors(prev => ({ ...prev, starttime: '' })); }}
                                                        showIcon
                                                        timeOnly
                                                        icon={() => <i className="pi pi-clock" />}
                                                        className={formErrors.starttime ? 'p-invalid' : ''}
                                                    /> */}
                          {formErrors.starttime && (
                            <small className="p-error">
                              {formErrors.starttime}
                            </small>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            End date
                          </label>
                          <Calendar
                            value={enddate}
                            dateFormat="yy-mm-dd"
                            minDate={
                              startdate
                                ? new Date(
                                    new Date(startdate).setDate(
                                      new Date(startdate).getDate()
                                    )
                                  )
                                : null
                            } // Only after start date
                            disabled={!startdate}
                            onChange={e => {
                              setenddate(e.value)
                            }}
                            showIcon
                          />
                          {/* <Calendar
                                                        value={enddate}
                                                        onChange={(e) => { setenddate(e.value); setFormErrors(prev => ({ ...prev, enddate: '' })); }}
                                                        showIcon
                                                        minDate={startdate || new Date()}
                                                        className={formErrors.enddate ? 'p-invalid' : ''}
                                                    /> */}
                          {formErrors.enddate && (
                            <small className="p-error">
                              {formErrors.enddate}
                            </small>
                          )}
                        </div>
                      </Col>
                      <Col xl={6}>
                        <div className="flex-auto">
                          <label htmlFor="buttondisplay" className="block">
                            Time
                          </label>
                          <Calendar
                            value={endtime}
                            onChange={e => {
                              setendtime(e.value)
                            }}
                            showIcon
                            timeOnly
                            icon={() => <i className="pi pi-clock" />}
                          />
                          {/* <Calendar
                                                        value={endtime}
                                                        onChange={(e) => { setendtime(e.value); setFormErrors(prev => ({ ...prev, endtime: '' })); }}
                                                        showIcon
                                                        timeOnly
                                                        icon={() => <i className="pi pi-clock" />}
                                                        className={formErrors.endtime ? 'p-invalid' : ''}
                                                    /> */}
                          {formErrors.endtime && (
                            <small className="p-error">
                              {formErrors.endtime}
                            </small>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="mb-4">
                <LinkContactJob
                  setSelectedScheduleJob={setSelectedScheduleJob}
                  setSelectedScheduleContacts={setSelectedScheduleContacts}
                  formErrors={formErrors} // Pass formErrors to the component
                  setFormErrors={setFormErrors}
                />
                <Row className="mb-2">
                  <LinkCandidatesPopup
                    formErrors={formErrors} // Pass formErrors to the component
                    setFormErrors={setFormErrors}
                    setSelectedScheduleCandidates={
                      setSelectedScheduleCandidates
                    }
                  />
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username" className="mb-0">
                        Subject{" "}
                      </label>
                      <InputText
                        placeholder="Subject"
                        value={subjectval}
                        onChange={e => {
                          setsubjectval(e.target.value)
                          setFormErrors(prev => ({ ...prev, subjectval: "" }))
                        }}
                        className={formErrors.subjectval ? "p-invalid" : ""}
                      />
                      {/* {formErrors.subjectval && <small className="p-error">{formErrors.subjectval}</small>} */}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className={`w-full ${
                          formErrors.popTextares ? "p-invalid" : ""
                        }`}
                        value={popTextares}
                        onChange={e => {
                          setPopTextares(e.target.value)
                          setFormErrors(prev => ({ ...prev, popTextares: "" }))
                        }}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                      {/* {formErrors.popTextares && <small className="p-error">{formErrors.popTextares}</small>} */}
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  {callingtask ? (
                    <>
                      <Col xl={4}>
                        <div className="p-field">
                          <label htmlFor="username">Auto Followup</label>
                          <Dropdown
                            value={followup}
                            onChange={e => setFollowup(e.value)}
                            options={followupOptions}
                            optionLabel="name"
                            placeholder="Select a Followup Interval"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>

                      <Col xl={4}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="username">Repeat</label>
                          <Dropdown
                            value={repeat}
                            onChange={e => setRepeat(e.value)}
                            options={repeatOptions}
                            optionLabel="name"
                            placeholder="Select a Repeat Option"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}

                  <Col xl={4}>
                    <div className="p-field">
                      <label htmlFor="reminder">Reminder</label>
                      <select
                        value={reminder}
                        onChange={e => setReminder(e.target.value)}
                        className="form-control"
                      >
                        <option value="10 minutes">10 mins</option>
                        <option value="20 minutes">20 mins</option>
                        <option value="30 minutes">30 mins</option>
                      </select>
                    </div>
                    {/* <div className="p-field flex flex-column">
                                                    <label htmlFor="username">Reminder</label>
                                                    <Dropdown
                                                        value={reminder}
                                                        onChange={(e) => setReminder(e.value)}
                                                        options={reminderOptions}
                                                        optionLabel="name"
                                                        placeholder="Select a Reminder"
                                                        className="w-full search-option"
                                                    />
                                                </div> */}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label htmlFor="Priority" className="block">
                            Priority
                          </label>
                          <Dropdown
                            value={priority}
                            onChange={e => {
                              setPriority(e.value)
                              setFormErrors(prev => ({ ...prev, priority: "" }))
                            }}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className={`w-full search-option ${
                              formErrors.priority ? "p-invalid" : ""
                            }`}
                          />
                          {/* {formErrors.priority && <small className="p-error">{formErrors.priority}</small>} */}
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      readOnly
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <Button
                      type="button"
                      className="btn btn-success me-2"
                      onClick={handleSaveSchedule}
                      disabled={isSubmitting}
                      label={
                        <>
                          <i className="pi pi-save me-1"></i>
                          {isSubmitting ? "Saving..." : "Save"}
                        </>
                      }
                    />
                    <Button
                      type="button"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                      onClick={() => {
                        setInterviewPop(false)
                        setSelectedScheduleOption(null)
                        resetForm()
                      }}
                      label={
                        <>
                          <i className="pi pi-times me-1"></i>Cancel
                        </>
                      }
                    />
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
      ) : (
        <Dialog
          header="Selection Required"
          visible={interviewPop}
          style={{ width: "30vw" }}
          onHide={() => {
            setInterviewPop(false)
            setSelectedScheduleOption(null)
          }}
        >
          <div className="p-3">
            <p>Please select one company to proceed.</p>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary"
                onClick={() => {
                  setInterviewPop(false)
                  setSelectedScheduleOption(null)
                }}
              >
                OK
              </button>
            </div>
          </div>
        </Dialog>
      )}
      {/* Interview schedule end */}

      {/* View start */}
      <Row>
        <Col lg={12}>
          <Sidebar
            visible={visibleViewRight}
            position="right"
            onHide={() => setVisibleViewRight(false)}
            className="view-form-sidebar"
          >
            <div className="sidebar-header">
              <h3 className="head">
                <i className="pi pi-users"></i> Company -{" "}
                {selectedCustomers?.length > 0
                  ? `${selectedCustomers[0]?.company_name || conamyname}`
                  : " "}{" "}
              </h3>
              <div className="d-flex align-items-center">
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={() => setVisibleViewRight(false)}
                />
              </div>
            </div>
            <TabView className="mt-4">
              <TabPanel header="Profile" leftIcon="pi pi-user mr-2">
                <Row>
                  <Col lg={12}></Col>
                  <Col lg={12}>
                    <Accordion activeIndex={0}>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">
                              PROFILE INFORMATION
                            </span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row className="mb-2">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="company" className="block">
                                Company
                              </label>
                              <InputText
                                id="company"
                                placeholder=""
                                className="block w-full"
                                value={conamyname}
                                disabled
                                onChange={e => setconamyname(e.value)}
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="website" className="block">
                                Website
                              </label>
                              <InputText
                                id="website"
                                type="url"
                                placeholder=""
                                className="block w-full"
                                value={website}
                                disabled
                                onChange={e => setWebsite(e.value)}
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="email" className="block">
                                Email
                              </label>
                              <InputText
                                id="email"
                                type="email"
                                placeholder=""
                                className="block w-full"
                                value={workEmail}
                                disabled
                                onChange={e => setWorkEmail(e.target.value)}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="phone" className="block">
                                Phone Number
                              </label>
                              <InputText
                                id="phone"
                                type="tel"
                                placeholder=""
                                className="block w-full"
                                value={phoneNumber}
                                disabled
                                onChange={e => setPhoneNumber(e.target.value)}
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="yearFounded" className="block">
                                Year Founded
                              </label>
                              <DatePicker
                                id="EmpMang_YearDatePicker"
                                className="form-select Mukta_Font SelectYearDatePicker"
                                selected={startyear}
                                disabled
                                onChange={date => {
                                  setstartyear(date)
                                }}
                                showYearPicker
                                dateFormat="yyyy"
                                maxDate={new Date()}
                                placeholderText="Please select a Year"
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="specialties" className="block">
                                Specialties
                              </label>
                              <InputText
                                disabled
                                placeholder="Enter specialties"
                                className="w-full activejobdrop"
                                {...register("Specialties", {})}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="industry" className="block">
                                Industry
                              </label>
                              <Dropdown
                                id="industry"
                                disabled
                                value={industry}
                                onChange={e => setIndustry(e.value)}
                                options={industryview}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                filterPlaceholder="Search Industry"
                                className="w-full activejobdrop"
                                placeholder="Select industry..."
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="companySize">Company Size</label>
                              <Dropdown
                                value={companysize}
                                disabled
                                onChange={value => setcompanysize(value)}
                                options={companysizeview}
                                optionLabel="name"
                                optionValue="name"
                                // filter
                                // filterPlaceholder="Company Size"
                                className="w-full activejobdrop"
                                placeholder="Select size..."
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="jobType">Categories</label>
                              <InputText
                                value={categoriesItem}
                                disabled
                                // onChange={(e) => setSelectedCategoryKey(e.value)}
                                // options={categoriesitem}
                                // optionLabel="name"
                                // optionValue="id"
                                // filter
                                className="w-full activejobdrop"
                                placeholder="Select Category"
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2 align-items-end">
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="jobType">Groups</label>
                              <InputText
                                value={groupItem}
                                disabled
                                // onChange={(e) => setSelectedGroupKey(e.value)}
                                // options={groupitem}
                                // optionLabel="name"
                                // optionValue="id"
                                // filter
                                className="w-full activejobdrop"
                                placeholder="Select Group..."
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <input
                                type="checkbox"
                                disabled
                                className="me-2"
                                checked={isPrivate}
                                onChange={() => {}} // Add an empty onChange to prevent React warnings for controlled inputs
                              />
                              <label htmlFor="jobType">Private</label>
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="address" className="block">
                                Address
                              </label>
                              <InputTextarea
                                id="address"
                                placeholder=""
                                className="block w-full"
                                value={address}
                                onChange={e => setAddress(e.value)}
                                disabled
                                rows={3}
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="overview" className="block">
                                Overview
                              </label>
                              <InputTextarea
                                id="overview"
                                className="block w-full"
                                value={description}
                                // disabled
                                readOnly
                                rows={3}
                                placeholder="Company overview will appear here"
                              />
                            </div>
                          </Col>
                        </Row>

                        {/* <Row>
                          <Col lg={12}>
                            <div className="p-field">
                              <label htmlFor="jobType" className="block">
                                Notes
                              </label>
                              <InputTextarea
                                autoResize
                                disabled
                                value={notes}
                                // onChange={(e) => setDescription(e.target.value)}
                                rows={5}
                                cols={40}
                                placeholder=""
                                className="w-full "
                              />
                            </div>
                          </Col>
                        </Row> */}
                      </AccordionTab>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">
                              DOCUMENTS
                            </span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row>
                          <Col lg={12}>
                            <div className="doc-table">
                              {documentsLoading && (
                                <div className="flex justify-content-center align-items-center">
                                  <ProgressSpinner />
                                </div>
                              )}
                              {/* {!documentsLoading && documentsError && (
                                                                <p className="text-danger">{documentsError}</p>
                                                            )}
                                                            {!documentsLoading && !documentsError && documents.length === 0 && (
                                                                <p>No documents available.</p>
                                                            )}
                                                            {!documentsLoading && !documentsError && documents.length > 0 && ( */}
                              <DataTable
                                value={documents}
                                tableStyle={{ minWidth: "50rem" }}
                                dataKey="key"
                                paginator
                                rows={5}
                                emptyMessage="No Documents Available"
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                              >
                                <Column
                                  field="docType"
                                  header="Document Type"
                                  body={rowData =>
                                    columnBodyTemplate(rowData, "docType")
                                  }
                                  style={{ minWidth: "12rem" }}
                                />
                                <Column
                                  field="docSubject"
                                  header="Document Subject"
                                  body={rowData =>
                                    columnBodyTemplate(rowData, "docSubject")
                                  }
                                  style={{ minWidth: "12rem" }}
                                />
                                <Column
                                  field="appliedDateTime"
                                  header="Applied Date & Time"
                                  body={rowData =>
                                    columnBodyTemplate(
                                      rowData,
                                      "appliedDateTime"
                                    )
                                  }
                                  style={{ minWidth: "12rem" }}
                                />
                                <Column
                                  field="attachments"
                                  header="Attachments"
                                  body={attachmentBodyTemplate}
                                  style={{ minWidth: "12rem" }}
                                />
                                <Column
                                  headerClassName="w-10rem"
                                  header="Actions"
                                  body={actionTemplate}
                                />
                              </DataTable>
                              {/* )} */}
                            </div>
                          </Col>
                        </Row>
                      </AccordionTab>
                    </Accordion>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={filteredActivities}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={rowsPerPage}
                          first={(currentPage - 1) * rowsPerPage}
                          totalRecords={activityTotalRecords}
                          onPage={e => {
                            setRowsPerPage(e.rows)
                            setCurrentPage(e.page + 1)
                            fetchActivities(
                              selectedCustomers[0].company_id,
                              e.page + 1,
                              e.rows
                            )
                          }}
                          lazy
                          onFilter={e => setActivitiesFilters(e.filters)}
                          rowsPerPageOptions={[5, 10, 25, 50, 100, 150]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={activitiesFilters}
                          filterDisplay="row"
                          emptyMessage="No activities found."
                          selection={selectedActivities}
                          onSelectionChange={e =>
                            setSelectedActivities(e.value)
                          }
                          // selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                          loading={loading}
                        >
                          <Column
                            field="event_type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="event_sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="event_priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="status"
                            header="Status"
                            sortable
                            filter
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="start_date"
                            header="Start Date"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="end_date"
                            header="End Date"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="created_by_name"
                            header="Created By"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Pipeline" leftIcon="pi pi-cog mr-2">
                <Row>
                  <Col lg={12}>
                    <div className="pipelinetabs">
                      {stages.length === 0 ? (
                        <p>Loading stages or no stages available...</p>
                      ) : (
                        <TabView
                          scrollable
                          style={{ maxWidth: "1200px", overflow: "hidden" }}
                        >
                          {stages?.map(stage => (
                            <TabPanel
                              key={stage}
                              header={
                                stage?.charAt(0).toUpperCase() + stage?.slice(1)
                              }
                              rightIcon={
                                <Badge
                                  value={stageCounts[stage] || 0}
                                  severity="success"
                                  className="ml-2"
                                />
                              }
                              leftIcon="pi pi-cog mr-1"
                            >
                              <Row>
                                <Col lg={12}>
                                  <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable">
                                      <DataTable
                                        responsive
                                        showGridlines
                                        value={pipelineData[stage] || []}
                                        tableStyle={{
                                          minWidth: "50rem",
                                          borderRadius: "8px",
                                          boxShadow:
                                            "0 2px 5px rgba(0, 0, 0, 0.1)",
                                        }}
                                        paginator
                                        rows={5}
                                        rowsPerPageOptions={[
                                          5, 10, 25, 50, 100, 150,
                                        ]}
                                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                        currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        filters={filters[stage] || initFilters}
                                        filterDisplay="row"
                                        emptyMessage={`No ${stage} jobs found.`}
                                        selection={selectedJobs[stage] || []}
                                        onSelectionChange={e =>
                                          handleSelectionChange(stage, e.value)
                                        }
                                        // selectionMode="multiple"
                                        resizableColumns
                                        columnResizeMode="expand"
                                      >
                                        <Column
                                          field="stage"
                                          header="Stage"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by stage"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="jobid"
                                          header="Job ID"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by job ID"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="job_title"
                                          header="Job Title"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by job title"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="contact"
                                          header="Contact"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by contact"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="status"
                                          header="Status"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by status"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="create_date"
                                          header="Create Date"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by create date"
                                          style={{ minWidth: "12rem" }}
                                        />
                                        <Column
                                          field="createdBy"
                                          header="Created by Name"
                                          sortable
                                          filter
                                          filterPlaceholder="Search by user ID"
                                          style={{ minWidth: "12rem" }}
                                        />
                                      </DataTable>
                                    </div>
                                  </section>
                                </Col>
                              </Row>
                            </TabPanel>
                          ))}
                        </TabView>
                      )}
                    </div>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Contacts" leftIcon="pi pi-cog mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="contacts-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        {/* {contactsLoading && (
                                                    <div className="flex justify-content-center align-items-center">
                                                        <ProgressSpinner />
                                                    </div>
                                                )} */}
                        {/* {!contactsLoading && contactsError && (
                                                    <p className="text-danger">{contactsError}</p>
                                                )}
                                                {!contactsLoading && !contactsError && contacts.length === 0 && (
                                                    <p>No contacts available.</p>
                                                )}
                                                {!contactsLoading && !contactsError && contacts.length > 0 && ( */}
                        <DataTable
                          responsive
                          showGridlines
                          value={filteredContacts}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          lazy
                          rows={rowsPerPage}
                          first={(currentPage - 1) * rowsPerPage}
                          totalRecords={contactsTotalRecords}
                          onPage={e => {
                            setRowsPerPage(e.rows)
                            const newPage = e.page + 1
                            setCurrentPage(newPage)
                            fetchCompanyContacts(
                              selectedCustomers[0]?.company_id,
                              newPage
                            )
                          }}
                          onFilter={e => setContactsFilters(e.filters)}
                          rowsPerPageOptions={[5, 10, 25, 50, 100, 150]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={contactsFilters}
                          filterDisplay="row"
                          emptyMessage="No contacts found."
                          selection={selectedContacts}
                          onSelectionChange={e => setSelectedContacts(e.value)}
                          // selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }} /> */}
                          <Column
                            field="full_name"
                            header="Full Name"
                            sortable
                            filter
                            filterPlaceholder="Search by full name"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="job_title"
                            header="Job Title"
                            sortable
                            filter
                            filterPlaceholder="Search by job title"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="work_phone"
                            header="Work Phone"
                            sortable
                            filter
                            filterPlaceholder="Search by work phone"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="work_email"
                            header="Work Email"
                            sortable
                            filter
                            filterPlaceholder="Search by work email"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="city"
                            header="City"
                            sortable
                            filter
                            filterPlaceholder="Search by city"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            filterPlaceholder="Search by user ID"
                            style={{ minWidth: "12rem" }} 
                          />
                        </DataTable>
                        {/* )} */}
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Candidates" leftIcon="pi pi-calendar mr-2" className="nav-items">
                <Row>
                  <Col lg={12}>
                    <section className="candidates-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        {loading && (
                          <div className="flex justify-content-center align-items-center">
                            <ProgressSpinner />
                          </div>
                        )}
                        {/* {!loading && candidatesError && (
                                                    <p className="text-danger">{candidatesError}</p>
                                                )}
                                                {!loading && !candidatesError && candidates.length === 0 && (
                                                    <p>No candidates available.</p>
                                                )}
                                                {!loading && !candidatesError && candidates.length > 0 && ( */}
                        <DataTable
                          responsive
                          showGridlines
                          value={filteredCandidates}
                          lazy
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={rowsPerPage}
                          first={(currentPage - 1) * rowsPerPage}
                          totalRecords={candidateTotalRecords}
                          onPage={e => {
                            setRowsPerPage(e.rows)
                            const newPage = e.page + 1
                            setCurrentPage(newPage)
                            fetchCompanyCandidates(
                              selectedCustomers[0]?.company_id,
                              newPage
                            )
                          }}
                          rowsPerPageOptions={[5, 10, 25, 50, 100, 150]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={candidatesFilters}
                          filterDisplay="row"
                          emptyMessage="No candidates found."
                          selection={selectedCandidates}
                          onFilter={e => {
                            setCandidatesFilters(e.filters)
                            setCurrentPage(1)
                          }}
                          onSelectionChange={e =>
                            setSelectedCandidates(e.value)
                          }
                          // selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }} /> */}
                          <Column
                            field="full_name"
                            header="Full Name"
                            sortable
                            filter
                            filterPlaceholder="Search by full name"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="job_title"
                            header="Job Title"
                            sortable
                            filter
                            filterPlaceholder="Search by job title"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="mob_phone"
                            header="Mobile Phone"
                            sortable
                            filter
                            filterPlaceholder="Search by mobile phone"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="email"
                            header="Email"
                            sortable
                            filter
                            filterPlaceholder="Search by email"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="city"
                            header="City"
                            sortable
                            filter
                            filterPlaceholder="Search by city"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            filterPlaceholder="Search by user ID"
                            style={{ minWidth: "12rem" }}
                          />
                        </DataTable>
                        {/* )} */}
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="History" leftIcon="pi pi-clock mr-2" className="nav-items nav-items1">
                <Row>
                  <Col lg={12} sm={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        {loading && (
                          <div className="flex justify-content-center align-items-center">
                            <ProgressSpinner />
                          </div>
                        )}
                        {/* {!loading && historyError && (
                                                    <p className="text-danger">{historyError}</p>
                                                )}
                                                {!loading && !historyError && history.length === 0 && (
                                                    <p>No history available.</p>
                                                )}
                                                {!loading && !historyError && history.length > 0 && ( */}
                        <DataTable
                          responsive
                          showGridlines
                          value={filteredHistory}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          lazy
                          rows={rowsPerPage}
                          first={(currentPage - 1) * rowsPerPage}
                          onPage={e => {
                            setRowsPerPage(e.rows)
                            const newPage = e.page + 1
                            setCurrentPage(newPage)
                            fetchCompanyHistory(
                              selectedCustomers[0]?.company_id,
                              newPage
                            )
                          }}
                          onFilter={e => {
                            setHistoryFilters(e.filters)
                            setCurrentPage(1)
                          }}
                          totalRecords={historyTotalRecords}
                          rowsPerPageOptions={[5, 10, 25, 50, 100, 150]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={historyFilters}
                          filterDisplay="row"
                          emptyMessage="No history found."
                          selection={selectedHistory}
                          onSelectionChange={e => setSelectedHistory(e.value)}
                          // selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          {/* <Column selectionMode="multiple" headerStyle={{ width: "3em" }} /> */}
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            filterPlaceholder="Search by type"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            filterPlaceholder="Search by sub type"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            filterPlaceholder="Search by priority"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            filterPlaceholder="Search by subject"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="dateTime"
                            header="Date and Time"
                            sortable
                            filter
                            filterPlaceholder="Search by date and time"
                            style={{ minWidth: "12rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            filterPlaceholder="Search by user ID"
                            style={{ minWidth: "12rem" }}
                          />
                        </DataTable>
                        {/* )} */}
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2" className="nav-items nav-items1">
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-end">
                      <Button
                        type="button"
                        label="Add Notes"
                        icon="pi pi-plus"
                        className="btn btn-primary waves-light me-2 sidebarbtn"
                        onClick={handleAddNotes}
                        disabled={
                          notesLoading || !selectedCustomers[0]?.company_id
                        }
                      />
                    </div>
                  </Col>
                </Row>

                {isEditorVisible && (
                  <Row className="mt-4">
                    <Col lg={12}>
                      <Editor
                        value={editorContent}
                        onTextChange={e => setEditorContent(e.htmlValue || "")}
                        style={{ height: "200px" }}
                        placeholder="Enter your notes here..."
                      />
                      {notesError && (
                        <small className="p-error block mt-2">
                          {notesError}
                        </small>
                      )}
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          type="button"
                          label="Save"
                          icon="pi pi-save"
                          className="btn btn-success me-2"
                          onClick={handleSaveNotes}
                          disabled={notesLoading}
                        />
                        <Button
                          color="primary"
                          className="btn btn-primary waves-light me-2 cancel-outlinebtn"
                          onClick={handleCancelNotes}
                          disabled={notesLoading}
                        >
                          <i className="pi pi-times me-1"></i>
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4 notes">
                  <Col lg={12}>
                    {notesLoading && (
                      <div className="flex justify-content-center align-items-center">
                        <ProgressSpinner />
                      </div>
                    )}
                    {!notesLoading &&
                      companyNotes.length === 0 &&
                      !notesError && (
                        <p className="mr-2">No notes available.</p>
                      )}
                    {!notesLoading && companyNotes.length > 0 && (
                      <Card className="pt-0 pb-0">
                        {companyNotes?.map(note => (
                          <div key={note?.id}>
                            <div className="d-flex mt-0">
                              <strong className="text-muted me-4">
                                Note: {note?.created_by_name}
                              </strong>
                              <strong className="text-muted">
                                Saved on:{" "}
                                {moment(note?.created_at).format(
                                  "YYYY-MM-DD HH:mm"
                                )}
                              </strong>
                            </div>
                            <div className="d-flex justify-content-between mt-2 mb-0">
                              <div
                                dangerouslySetInnerHTML={{ __html: note.notes }}
                              />
                              <div>
                                <Button
                                  icon="pi pi-pencil"
                                  className="btn btn-warning editbtn p-0"
                                  onClick={() => handleEditNote(note)}
                                  disabled={notesLoading}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="btn btn-danger deletebtn"
                                  onClick={() => handleDeleteNote(note.note_id)}
                                  disabled={notesLoading}
                                />
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </Card>
                    )}
                  </Col>
                </Row>
              </TabPanel>
            </TabView>
          </Sidebar>
        </Col>
      </Row>
      {/* View end */}
    </React.Fragment>
  )
}
export default CompaniesAllActive
